/**
 * UI dictionaries. Greek is the default and uses HPress's own labels where a label was observed
 * (docs/hpress-discovery.md); English is a translation for the same keys.
 */
export const el = {
  appName: 'AirPost',
  appSubtitle: 'Ηλεκτρονικό Συντακτικό Σύστημα Ειδήσεων',
  station: 'ALPHA TV Κύπρου',
  // top links
  home: 'Αρχική Σελίδα',
  print: 'Εκτύπωση',
  help: 'Οδηγίες',
  faq: 'FAQ',
  logout: 'Logout',
  changePassword: 'Change Password',
  currentPassword: 'Τρέχων κωδικός',
  newPassword: 'Νέος κωδικός',
  repeatPassword: 'Επανάληψη νέου κωδικού',
  passwordRule: 'Ο νέος κωδικός χρειάζεται τουλάχιστον 10 χαρακτήρες',
  passwordMismatch: 'Οι δύο κωδικοί δεν ταιριάζουν',
  passwordChanged: 'Ο κωδικός άλλαξε· ισχύει από την επόμενη σύνδεση',
  user: 'Χρήστης',
  // tabs
  tabNews: 'Ειδήσεις',
  tabTopics: 'Θεματολόγιο',
  tabVideo: 'Αρχείο Video',
  tabHub: 'Video Hub',
  tabAdmin: 'Διαχείριση',
  // submenu
  newStory: 'Νέα Είδηση',
  dayStories: 'Ειδήσεις Ημέρας',
  rundownGuide: 'Οδηγός Δελτίου',
  quickFind: 'Γρήγορη Αναζήτηση',
  archive: 'Αρχείο Ειδήσεων',
  // login
  loginTitle: 'Μοναδική Σύνδεση - AirPost',
  loginHint: "Δώστε 'Χρήστη' και 'Κωδικό' και πατήστε 'Σύνδεση' για να συνδεθείτε στην εφαρμογή",
  username: 'Χρήστης',
  password: 'Κωδικός',
  login: 'Σύνδεση',
  // rundown selection
  rundownTitle: 'Οδηγός Δελτίου',
  rundownSelectHint: "Επιλέξτε 'Δελτίο' και 'Ημερομηνία' και πατήστε 'Αναζήτηση'",
  bulletinDetails: 'Στοιχεία Δελτίου',
  bulletin: 'Δελτίο',
  bulletinDate: 'Ημ/νία Δελτίου',
  choose: '< Επιλέξτε Δελτίο >',
  search: 'Αναζήτηση',
  clear: 'Καθαρισμός',
  tipRequired: 'Τα πεδία "Δελτίο" και "Ημερομηνία δελτίου" είναι υποχρεωτικά',
  todaysRundowns: 'Σημερινά δελτία',
  // grid
  gridTitle: 'ΟΔΗΓΟΣ ΔΕΛΤΙΟΥ',
  gridHint: "Επιλέξτε εικονίδιο για 'Τροποποίηση στον Οδηγό' για να αλλάξετε Αρ. Θέματος και Τίτλο. Στην συνέχεια πατήστε στο εικονίδιο της 'Αποθήκευσης'.",
  colSel: 'Ε',
  colActions: 'Ενέργειες',
  rowMore: 'Περισσότερα',
  colNum: 'Αρ.Θέμ.',
  colTitle: 'Τίτλος',
  colCat: 'Κατ.',
  colRead: 'Χρ.Μετ.',
  colVideo: 'Χρ.VIDEO',
  colTotal: 'Συν. Χρ.',
  colRt: 'RT',
  colOrder: 'Σ.Μ.',
  colType: 'Τύπος',
  colPlayout: 'Playout',
  colGraphics: 'Γραφικά',
  newsCount: 'Αρ. Ειδήσεων',
  bulletinTime: 'Xρόνος Δελτίου',
  revision: 'Αναθ.',
  cut: 'Αποκοπή',
  printBulletin: 'Εκτ. Δελτίου',
  printList: 'Εκτ. Λίστας',
  autocue: 'Autocue',
  showSelected: 'Εμφάνιση Επιλεγμένων',
  copyBulletin: 'Αντιγ. Δελτίου',
  refresh: 'Ανανέωση',
  publish: 'Δημοσίευση',
  selectAll: 'Επιλογή Όλων',
  selectNone: 'Κενή Επιλογή',
  tipCopy: 'Για την αντιγραφή Δελτίου δεν χρειάζεται να επιλέξετε Ειδήσεις. Αντιγράφονται ΟΛΕΣ οι Ειδήσεις του Δελτίου.',
  tipDash: "Για την τροποποίηση του Αρ. Θέματος στον οδηγό σε 'κενή τιμή' χρησιμοποιείστε το '-'.",
  tipKeys: 'Πλήκτρα: ↑↓ μετακίνηση, Enter άνοιγμα, F2 τροποποίηση στον Οδηγό, Alt+↑↓ αλλαγή σειράς, Space επιλογή, Insert διαχωριστικό, Delete αποκοπή ή αφαίρεση διαχωριστικού, F5 ανανέωση.',
  editInGuide: 'Τροποποίηση Στον Οδηγό',
  editRecord: 'Τροποποίηση Εγγραφής',
  viewRecord: 'Εμφάνιση Εγγραφής',
  save: 'Αποθήκευση',
  cancel: 'Ακύρωση',
  back: 'Επιστροφή',
  separator: 'Διαχωριστικό',
  separatorAddHint: 'Διαχωριστικό κάτω από την επιλεγμένη γραμμή (Insert)',
  separatorAddAfter: 'Διαχωριστικό ακριβώς κάτω από αυτή τη γραμμή',
  separatorLabel: 'Τίτλος διαχωριστικού (F2 ή διπλό κλικ· κενό για σκέτη μπάντα χρώματος)',
  separatorRemove: 'Αφαίρεση διαχωριστικού (Delete)',
  float: 'Αιώρηση',
  unfloat: 'Επαναφορά στη ροή',
  duplicateLinked: 'Διπλότυπο (κοινό κείμενο)',
  duplicateCopy: 'Αντίγραφο (ανεξάρτητο)',
  removed: 'Αποκομμένες',
  restore: 'Επαναφορά',
  confirmCut: 'Να αποκοπούν οι επιλεγμένες ειδήσεις από το δελτίο;',
  nothingSelected: 'Δεν έχετε επιλέξει ειδήσεις.',
  conflict: 'Το δελτίο άλλαξε από άλλον χρήστη. Ο οδηγός ενημερώθηκε· επαναλάβετε την ενέργεια.',
  live: 'ζωντανά',
  offline: 'εκτός σύνδεσης',
  reconnecting: 'επανασύνδεση…',
  present: 'Παρόντες',
  // dialogs
  copyTo: 'Αντιγραφή Δελτίου',
  copy: 'Αντιγραφή',
  copyConfirm: 'Να αντιγραφούν όλες οι ειδήσεις στο επιλεγμένο δελτίο;',
  copyDone: 'Ολοκληρώθηκε η αντιγραφή',
  selectedActions: 'Ενέργειες σε Επιλεγμένες Ειδήσεις',
  printSelected: 'Εκτύπωση Επιλεγμένων',
  backToGuide: 'Επιστροφή στον Οδηγό',
  device: 'Συσκευή Autocue',
  profile: 'Κωδικοποίηση',
  profileLegacy: 'win-1253 (όπως το HPress)',
  profileUtf8: 'UTF-8 (ξεχωριστό προφίλ)',
  preview: 'Προεπισκόπηση',
  send: 'Αποστολή',
  unsupportedChars: 'Χαρακτήρες που δεν υποστηρίζει η κωδικοποίηση win-1253',
  noUnsupported: 'Όλοι οι χαρακτήρες υποστηρίζονται.',
  fileWritten: 'Το αρχείο γράφτηκε',
  download: 'Λήψη',
  line: 'γραμμή',
  column: 'στήλη',
  // story
  storyEdit: 'Τροποποίηση Είδησης',
  storyNew: 'Νέα Είδηση',
  storyView: 'Εμφάνιση Είδησης',
  storyViewHint: 'Εμφάνιση στοιχείων είδησης',
  author: 'Συντάκτης',
  department: 'Τμήμα',
  origin: 'Προέλευση',
  category: 'Κατηγορία',
  title: 'Τίτλος',
  storyNumber: 'Αρ.Θέματος',
  guideComments: 'Σχόλια Οδηγού',
  text: 'Κείμενο',
  createdAt: 'Ημ/νία Κατ/σης',
  createdBy: 'Καταχ/ση από',
  updatedAt: 'Τελ. Τροπ/ση',
  updatedBy: 'Τροπ/ση Από',
  readTime: 'Χρ. Μεταδ.',
  readOverride: 'Χρ.Μετ. (χειροκίνητα)',
  videoTime: 'Χρ.VIDEO',
  order: 'Σειρά Μετάδοσης',
  itemType: 'Τύπος',
  cue: 'Cue',
  insertTemp: 'Εισαγ. Προσωρ. Αρχείου',
  saveTemp: 'Προσωρ. Αποθήκ.',
  revert: 'Επαναφορά',
  history: 'Ιστορικό',
  pdf: 'PDF',
  tipRequiredFields: 'Με * εμφανίζονται τα υποχρεωτικά πεδία',
  stateLocal: 'Πρόχειρο τοπικά',
  stateSaved: 'Αποθηκεύτηκε στο AirPost',
  savedPopup: 'Αποθηκεύτηκε',
  statePublished: 'Δημοσιεύτηκε',
  stateAcked: 'Επιβεβαιώθηκε',
  statePending: 'Αποθήκευση…',
  stateError: 'Σφάλμα αποθήκευσης',
  stateConflict: 'Σύγκρουση: η είδηση άλλαξε από',
  keepMine: 'Δική μου',
  keepTheirs: 'Δική τους',
  leasedBy: 'Το επεξεργάζεται ο/η',
  readOnlyNow: 'Μόνο ανάγνωση',
  words: 'λέξεις',
  computed: 'υπολογισμένος',
  // lists
  dayTitle: 'Ειδήσεις Ημέρας',
  dayHint: "Πατήστε το εικονίδιο στην στήλη 'Τ' για τροποποίηση της είδησης ή στο link του 'Τίτλου' για να δείτε λεπτομέρειες της είδησης.",
  go: 'Μετάβαση',
  colEdit: 'Τ',
  colCreatedBy: 'Δημιουργία από',
  colBulletin: 'Δελτίο',
  colUpdated: 'Ημ/νία Τελ. Τροπ.',
  totalTime: 'Συνολικός χρόνος ειδήσεων',
  tipDayDates: 'Η αναζήτηση είναι με σημερινή ή χθεσινή ημερομηνία δελτίου. Η αρχική ταξινόμηση είναι με "Ημ/νία Τελ.Τροπ" φθίνουσα. Μπορείτε να αλλάξετε την ταξινόμηση πατώντας την επικεφαλίδα στην αντίστοιχη στήλη.',
  previous: 'Προηγούμενα',
  next: 'Επόμενα',
  of: 'από',
  quickTitle: 'Γρήγορη Αναζήτηση στο τμήμα',
  archiveTitle: 'Σύνθετη Αναζήτηση στο αρχείο ειδήσεων',
  searchHint: "Συμπληρώστε τα πεδία για αναζήτηση και πατήστε 'Αναζήτηση'",
  fromDate: 'από',
  toDate: 'έως',
  datePlaceholder: 'ΗΗ/ΜΜ/ΕΕΕΕ',
  pickDate: 'Ημερολόγιο',
  badDate: 'Μη έγκυρη ημερομηνία (ΗΗ/ΜΜ/ΕΕΕΕ)',
  createdFrom: 'Καταχώρηση από',
  updatedFrom: 'Τελ. τροπ. από',
  comments: 'Σχόλια',
  records: 'Εγγραφές',
  sorting: 'Ταξινόμηση',
  direction: 'Σειρά',
  asc: 'Αύξουσα',
  desc: 'Φθίνουσα',
  byOrder: 'Σειρά Μετάδοσης',
  byUpdated: 'Ημ/νία τελευταίας τροποποίησης',
  results: 'Αποτελέσματα',
  noResults: 'Δεν βρέθηκαν ειδήσεις',
  tipOperators: 'Στα πεδία κειμένου: λέξεις με κόμμα ή κενό (όλες), % και _ για μπαλαντέρ, & | ~ ή AND OR NOT.',
  welcome: 'Καλωσήρθατε στο Ηλεκτρονικό Συντακτικό Σύστημα',
  homeGoodMorning: 'Καλημέρα',
  homeGoodAfternoon: 'Καλησπέρα',
  homeGoodEvening: 'Καλησπέρα',
  homeKpiBulletins: 'δελτία σήμερα',
  homeKpiRows: 'θέματα στα δελτία',
  homeKpiFeedsHour: 'νέα στα feeds την τελευταία ώρα',
  homeNoRundowns: 'Δεν έχει ανοίξει δελτίο για σήμερα. Ανοίξτε ένα από τον Οδηγό Δελτίου.',
  homeRowsUnit: 'θέματα',
  homeLatestStories: 'Τελευταίες ειδήσεις',
  homeNoStories: 'Καμία είδηση σήμερα ακόμη.',
  homeAllFeeds: 'Όλα τα feeds',
  homeNoFeeds: 'Δεν υπάρχουν ακόμη ροές. Ο διαχειριστής προσθέτει πηγές από Διαχείριση → Feeds.',
  homeFeedsLocal: 'Κύπρος',
  homeFeedsWorld: 'Διεθνή',
  homeChooseFeeds: 'Επιλογή ροών',
  homeChooseFeedsHint: 'Ποιες ροές εμφανίζονται στη δική σας αρχική σελίδα. Χωρίς επιλογή εμφανίζονται όλες.',
  homeUpdated: 'Ενημέρωση',
  draft: 'Πρόχειρο',
  statusDraft: 'ΠΡΟΧΕΙΡΟ',
  statusDraftShort: 'ΠΡΟΧ.',
  statusReady: 'ΟΡΙΣΤΙΚΟ',
  statusReadyShort: 'ΟΡΙΣΤ.',
  statusApproved: 'ΕΓΚΕΚΡΙΜΕΝΟ',
  statusApprovedShort: 'ΕΓΚΡ.',
  finalise: 'Οριστικοποίηση',
  finaliseHint: 'Η είδηση παύει να είναι πρόχειρο· οι αλλαγές συνεχίζουν να αποθηκεύονται αυτόματα, αλλά μια αλλαγή συντάκτη την ξανακάνει πρόχειρο',
  backToDraft: 'Πίσω σε πρόχειρο',
  backToDraftHint: 'Η είδηση γίνεται ξανά πρόχειρο',
  approve: 'Έγκριση',
  approveHint: 'Έγκριση αρχισυντάκτη· μόνο όποιος έχει δικαίωμα C',
  unapprove: 'Άρση έγκρισης',
  demotedNote: 'Η αλλαγή έκανε την είδηση ξανά πρόχειρο· οριστικοποιήστε την πάλι όταν τελειώσετε.',
  draftAutosaveNote: 'αποθηκεύεται αυτόματα όσο γράφετε',

  linked: 'Συνδεδεμένο',
  published: 'Δημοσιευμένο',
  pending: 'Σε αναμονή',
  synced: 'Συγχρονισμένο',
  blocked: 'Μπλοκαρισμένο',
  failed: 'Απέτυχε',
  unlinked: 'Ασύνδετο',
  loading: 'Φόρτωση…',
  error: 'Σφάλμα',
  today: 'Σήμερα',
  // Θεματολόγιο
  topicsMenuSearch: 'Αναζήτηση Θεματολογίου',
  topicsMenuNew: 'Νέο Θεματολόγιο',
  topicsSearchTitle: 'Αναζήτηση στο Θεματολόγιο',
  topicsHint: 'Ο προεπιλεγμένος αριθμός εμφάνισης των εγγραφών είναι 100 και η ταξινόμηση γίνεται με βάση την ημερομηνία και ώρα, αύξουσα',
  topicDetails: 'Στοιχεία Θέματος',
  topicNew: 'Νέο Θέμα',
  topicEdit: 'Τροποποίηση Θέματος',
  topic: 'Θέμα',
  topicDate: 'Ημ/νία',
  topicTime: 'Ώρα',
  reporter: 'Ρεπόρτερ',
  appointment: 'Ραντεβού',
  remarks: 'Παρατηρήσεις',
  originPerson: 'Προέλευση (πρόσωπο)',
  originFree: 'Προέλευση (κείμενο)',
  topicsNone: 'Δεν βρέθηκαν θέματα',
  topicsMore: 'Υπάρχουν περισσότερες εγγραφές· περιορίστε την αναζήτηση ή αυξήστε τις Εγγραφές',
  topicsCount: 'θέματα',
  tomorrow: 'Αύριο',
  thisWeek: 'Εβδομάδα',
  delete: 'Διαγραφή',
  confirmDeleteTopic: 'Να διαγραφεί το θέμα; Παραμένει στο ιστορικό.',
  topicConflict: 'Το θέμα τροποποιήθηκε από άλλον χρήστη. Εμφανίζεται η τρέχουσα έκδοση· ξαναπεράστε τις αλλαγές σας.',
  topicSaved: 'Το θέμα αποθηκεύτηκε',
  anyCategory: '< Επιλέξτε Κατηγορία >',
  nobody: '< Κανένας >',
  freeText: 'Κείμενο',
  action: 'Ενέργεια',
  by: 'Από',
  when: 'Πότε',
  // Αρχείο Video
  videoHubMenu: 'Video Hub',
  hubTitle: 'Video Hub',
  hubHint: 'Όλα τα video του playout: διαλέξτε ένα και ανοίξτε το στο Μοντάζ· κόψιμο, φάσες, σπικάζ και μουσική στο timeline.',
  mamTitle: 'Video Hub',
  mamHint: 'Όλα τα video του playout· φίλτρα, αναζήτηση, στοιχεία κάθε clip και ο δρόμος προς το Μοντάζ',
  mamSearch: 'Αναζήτηση τίτλου, αρχείου ή ID',
  mamSort: 'Ταξινόμηση',
  mamSortNewest: 'Νεότερα',
  mamSortTitle: 'Τίτλος',
  mamSortLength: 'Διάρκεια',
  mamSortFile: 'Αρχείο',
  mamGrid: 'Πλέγμα',
  mamList: 'Λίστα',
  mamResults: 'clips',
  mamFacetStatus: 'Κατάσταση',
  mamFacetUse: 'Χρήση',
  mamFacetLength: 'Διάρκεια',
  mamFacetDate: 'Ημερομηνία',
  mamUsed: 'Σε χρήση',
  mamUnused: 'Αχρησιμοποίητα',
  mamNew: 'Νέα (24 ώρες)',
  mamLenShort: 'έως 15″',
  mamLenMid: '15″ – 1′',
  mamLenLong: 'πάνω από 1′',
  mamToday: 'Σήμερα',
  mamWeek: '7 ημέρες',
  mamOlder: 'Παλιότερα',
  mamClear: 'Καθαρισμός φίλτρων',
  mamNone: 'Κανένα clip με αυτά τα φίλτρα',
  mamPick: 'Διαλέξτε ένα clip από τη λίστα',
  mamAsset: 'Στοιχεία αρχείου',
  mamId: 'ID',
  mamFile: 'Αρχείο',
  mamDuration: 'Διάρκεια',
  mamStatus: 'Κατάσταση',
  mamSize: 'Μέγεθος',
  mamUpdated: 'Ενημερώθηκε στο playout',
  mamFirstSeen: 'Πρώτη εμφάνιση',
  mamLastSeen: 'Τελευταία εμφάνιση',
  mamLibrary: 'Βιβλιοθήκη playout',
  mamUses: 'Χρήση σε ειδήσεις',
  mamNoUses: 'Δεν χρησιμοποιείται σε είδηση',
  mamCopyId: 'Αντιγραφή ID',
  mamCopied: 'Αντιγράφηκε',
  mamProxy: 'Λήψη proxy',
  mamKeys: 'Βέλη: επιλογή · Enter ή διπλό κλικ: Μοντάζ',
  mamViaStoryboard: 'storyboard',
  mamViaStory: 'video της είδησης',
  mamViaRow: 'γραμμή δελτίου',
  mamPending: 'Περιμένουν αρχείο',
  mamPlayerEmpty: 'Διαλέξτε ένα asset για προεπισκόπηση',
  mamVu: 'Στάθμη ήχου (dBFS), αριστερό και δεξί κανάλι',
  mamSelection: 'Επιλογή',
  mamClearIn: 'Σβήσιμο IN',
  mamMarkIn: 'Σημείο IN',
  mamClearOut: 'Σβήσιμο OUT',
  mamMarkOut: 'Σημείο OUT',
  mamToStart: 'Στην αρχή',
  mamToIn: 'Στο IN',
  mamBack5: '5 καρέ πίσω',
  mamBack1: '1 καρέ πίσω',
  mamFwd1: '1 καρέ μπροστά',
  mamFwd5: '5 καρέ μπροστά',
  mamToOut: 'Στο OUT',
  mamToEnd: 'Στο τέλος',
  mamPlayRange: 'Αναπαραγωγή από το IN έως το OUT (Enter)',
  mamLoop: 'Επανάληψη ανάμεσα σε IN και OUT',
  mamMute: 'Σίγαση',
  mamColType: 'Τύπος',
  mamColStatus: 'Κατ.',
  mamColPreview: 'Προεπισκόπηση',
  mamColName: 'Όνομα',
  mamColDescription: 'Περιγραφή',
  mamColDuration: 'Διάρκεια',
  mamColKind: 'Είδος asset',
  mamColInserted: 'Εισαγωγή',
  mamColOrigin: 'Θέση',
  mamColSize: 'Μέγεθος',
  mamColTags: 'Λέξεις-κλειδιά',
  mamColOnline: 'Online',
  mamColUsed: 'Σε χρήση',
  mamColEdits: 'Μοντάζ',
  mamColSubclips: 'Υποκλίπ',
  mamSecAll: 'Όλα τα assets',
  mamSecClip: 'Clips του playout',
  mamSecUpload: 'Εισαγωγές ειδήσεων',
  mamSecMusic: 'Μουσική',
  mamSecVoiceover: 'Σπικάζ',
  mamSecUsed: 'Clips σε χρήση',
  mamSecUnused: 'Αχρησιμοποίητα clips',
  mamSecNew: 'Νέα (24 ώρες)',
  mamKindClip: 'Clip playout',
  mamKindUpload: 'Εισαγωγή',
  mamKindMusic: 'Μουσική',
  mamKindVoiceover: 'Σπικάζ',
  mamViaOwner: 'ανήκει στην είδηση',
  mamAddedToBasket: 'στο καλάθι',
  mamItemUpdated: 'Τα IN/OUT του καλαθιού άλλαξαν',
  mamYou: 'εσείς',
  mamMetaSaved: 'Τα στοιχεία αποθηκεύτηκαν',
  mamSubclipName: 'Όνομα υποκλίπ (προαιρετικό)',
  mamNavLibrary: 'Βιβλιοθήκη',
  mamNavState: 'Κατάσταση',
  mamNavWork: 'Εργασία',
  mamBasket: 'Καλάθι',
  mamKeysHelp: '↑↓ επιλογή · X σημάδι · Ctrl+A όλα · B στο καλάθι · E Μοντάζ · Space, J K L αναπαραγωγή · I O σημεία · ← → καρέ · Enter IN→OUT',
  mamAssets: 'Assets',
  mamSearchAll: 'Αναζήτηση: τίτλος, αρχείο, περιγραφή, λέξη-κλειδί, είδηση ή ID',
  mamColumns: 'Στήλες',
  mamColumnsReset: 'Οι αρχικές στήλες',
  mamAddToBasket: 'Στο καλάθι',
  mamDownload: 'Λήψη',
  mamClearSelection: 'Καθαρισμός επιλογής (Esc)',
  mamSelected: 'επιλεγμένα',
  mamNoneSearch: 'Κανένα asset δεν ταιριάζει στην αναζήτηση',
  mamNoneHere: 'Κανένα asset εδώ',
  mamCheckPage: 'Επιλογή όλης της σελίδας',
  mamRows: 'Γραμμές',
  mamOf: 'από',
  mamFirstPage: 'Πρώτη σελίδα',
  mamPrevPage: 'Προηγούμενη σελίδα',
  mamNextPage: 'Επόμενη σελίδα',
  mamLastPage: 'Τελευταία σελίδα',
  mamUpdateItem: 'Ενημέρωση καλαθιού',
  mamUpdateItemHint: 'Τα IN/OUT του player στο αντικείμενο του καλαθιού',
  mamAddRangeHint: 'Το asset με τα IN/OUT του στο καλάθι',
  mamSaveSubclipHint: 'Τα IN/OUT ως υποκλίπ του asset',
  mamSubclip: 'Υποκλίπ',
  mamEdit: 'Μοντάζ',
  mamEditHint: 'Ανοίγει το video στο Μοντάζ: το μοντάζ του σε είδησή σας, ή νέο μοντάζ αν έχετε βάλει σημεία IN–OUT· αν δεν παίζει σε καμία είδησή σας, φτιάχνεται είδηση γι’ αυτό',
  mamEditRangeHint: 'Νέο μοντάζ από το IN ως το OUT του player (χωρίς σημεία: όλο το video ή το μοντάζ που ήδη έχει)',
  mamEditOpening: 'Ανοίγει το Μοντάζ…',
  mamDetails: 'Λεπτομέρειες',
  mamPickAsset: 'Διαλέξτε ένα asset από τη λίστα',
  mamStationMusic: 'μουσική σταθμού',
  mamBasketTotal: 'Συνολική διάρκεια',
  mamMoveUp: 'Πάνω',
  mamMoveDown: 'Κάτω',
  mamRemoveTicked: 'Αφαίρεση επιλεγμένων',
  mamClearBasketConfirm: 'Ξανά για άδειασμα',
  mamClearBasket: 'Άδειασμα καλαθιού',
  mamToEdit: 'Σε μοντάζ',
  mamToEditHint: 'Το καλάθι γίνεται νέο μοντάζ: τα video με τη σειρά τους ως κομμάτια με τα IN/OUT τους, η μουσική στο A2, τα σπικάζ της είδησης στο A1',
  mamBasketEmpty: 'Σύρετε assets εδώ ή πατήστε B',
  mamGone: 'δεν υπάρχει πια',
  mamEditMade: 'Το μοντάζ φτιάχτηκε.',
  mamDroppedHint: 'Έμειναν έξω:',
  mamDroppedOther: 'ανήκει σε άλλη είδηση',
  mamDroppedLength: 'άγνωστη διάρκεια και χωρίς OUT',
  mamOpenEdit: 'Άνοιγμα μοντάζ',
  mamToStory: 'Σε υπάρχουσα είδηση',
  mamFindStory: 'Αναζητήστε την είδηση με τον τίτλο της',
  mamOwnsItems: 'έχει εισαγωγές ή σπικάζ του καλαθιού',
  mamToNewStory: 'Σε νέα είδηση',
  mamNewStoryTitle: 'Τίτλος της νέας είδησης',
  mamMakeEdit: 'Δημιουργία μοντάζ',
  mamOpenStory: 'Η είδηση',
  mamDescPlaceholder: 'Τι δείχνει, ποιος μιλά, πού και πότε γυρίστηκε',
  mamTagsPlaceholder: 'Λέξεις-κλειδιά, χωρισμένες με κόμμα',
  mamSubclips: 'Υποκλίπ',
  mamNoSubclips: 'Βάλτε IN και OUT στον player και πατήστε ✂ Υποκλίπ',
  mamEdits: 'Μοντάζ',
  mamNoEdits: 'Κανένα μοντάζ',
  mamHistory: 'Ιστορικό',

  hubAll: 'Όλα',
  hubNew: 'Νέα',
  hubUnused: 'Αχρησιμοποίητα',
  hubUsed: 'Σε χρήση',
  hubSearch: 'Αναζήτηση τίτλου ή αρχείου',
  hubRefresh: 'Ανανέωση',
  hubPending: 'Περιμένουν αρχείο:',
  hubNoClips: 'Δεν βρέθηκαν video',
  hubNewBadge: 'ΝΕΟ',
  hubUsedOnce: '1 είδηση',
  hubUsedMany: 'ειδήσεις',
  hubPickOne: 'Διαλέξτε ένα video από τη λίστα',
  hubStory: 'Είδηση',
  hubStoryNone: '— καμία —',
  hubStorySearch: 'Αναζήτηση είδησης για ανάθεση',
  hubAssign: 'Ανάθεση στην είδηση',
  hubAssigned: 'Το video μπήκε στην είδηση',
  hubNoStoryHint: 'Δεν παίζει σε καμία είδηση. Το Μοντάζ φτιάχνει μία με αυτό το video· ή διαλέξτε, βρείτε ή φτιάξτε μία εδώ.',
  hubNewStory: 'Νέα είδηση από το video',
  hubNewStoryHint: 'Δημιουργεί είδηση με τον τίτλο του video και το video στο κουτί ΒΙΝΤΕΟ ΜΕ ΗΧΟ',
  hubNewStoryDone: 'Η είδηση δημιουργήθηκε με το video μέσα· ανοίξτε το Μοντάζ στο timeline',
  hubTrim: 'Κόψιμο (in / out)',
  hubHere: 'Από το σημείο που παίζει το video',
  hubTrimSaved: 'Αποθηκεύτηκε το κόψιμο',
  hubRows: 'γραμμές δελτίου ενημερώθηκαν',
  hubStraps: 'Φάσες μέσα στο video',
  hubNoStrapsYet: 'Καμία φάσα ακόμη· γράψτε όνομα και ιδιότητα ή πάρτε μία πρόταση από το AI.',
  hubLine1: 'Γραμμή 1 (όνομα ή τίτλος)',
  hubLine2: 'Γραμμή 2 (ιδιότητα), προαιρετικά',
  hubAddStrap: 'Προσθήκη φάσας',
  hubAi: 'Προτάσεις AI',
  hubAiRun: 'Από το κείμενο της είδησης',
  hubAiHint: 'Το AI διαβάζει το κείμενο της είδησης και προτείνει πρόσωπα με ιδιότητα και σύντομους τίτλους· τίποτε δεν μπαίνει χωρίς το δικό σας κλικ',
  hubAiNothing: 'Το AI δεν βρήκε πρόσωπα ή τίτλους στο κείμενο',
  hubAiAddAtNow: 'Φάσα στο σημείο που παίζει το video',
  hubAiAdd: 'εδώ',
  hubReady: 'Έτοιμο για αέρα;',
  hubCheckClip: 'Clip στο playout',
  hubCheckStory: 'Είδηση',
  hubCheckNoStory: 'Δεν έχει μπει σε είδηση',
  hubCheckTrim: 'Κόψιμο',
  hubCheckFull: 'Παίζει ολόκληρο',
  hubCheckStraps: 'φάσες',
  hubCheckNoStraps: 'Χωρίς φάσες',
  hubVoiceover: 'Σπικάζ (voice-over)',
  voNone: 'Κανένα σπικάζ ακόμη',
  voScriptPh: 'Το κείμενο που θα διαβάσετε (προσυμπληρώνεται από το ΣΠΗΚΑΖ της είδησης)',
  voRecord: 'Ηχογράφηση',
  voRecordHint: 'Ηχογραφεί από το μικρόφωνο του υπολογιστή· το κείμενο μένει μπροστά σας',
  voStop: 'Στοπ',
  voSave: 'Αποθήκευση',
  voDiscard: 'Απόρριψη',
  voSaved: 'Το σπικάζ αποθηκεύτηκε στην είδηση',
  voMicDenied: 'Δεν δόθηκε άδεια για το μικρόφωνο',
  voAi: 'Φωνή AI',
  voRecorded: 'Ηχογράφηση',
  voAiRead: 'Να το διαβάσει η φωνή AI',
  voAiHint: 'Η φωνή AI (ElevenLabs) διαβάζει το κείμενο· το αρχείο μένει στην είδηση',
  voAiDone: 'Η φωνή AI διάβασε το κείμενο',
  voAiOff: 'Φωνή AI: προσθέστε το κλειδί ElevenLabs στα Κλειδιά API για να διαβάζει το κείμενο',
  voAirNote: 'Το σπικάζ μένει με την είδηση για τον σκηνοθέτη και τον ηχολήπτη· η μίξη του πάνω στις εικόνες δεν γίνεται ακόμη από το playout (εκκρεμεί το render).',
  veTitle: 'Μοντάζ',
  veBack: 'Πίσω στην είδηση',
  veToStory: 'Στην είδηση',
  veToStoryHint: 'οι αλλαγές του μοντάζ μπαίνουν στην είδηση, με export για να το δείχνει η προεπισκόπησή της',
  veToStoryBusy: 'μπαίνει στην είδηση',
  veToStoryAnyway: 'πατήστε ξανά «Στην είδηση» για επιστροφή χωρίς αυτό',
  veSaving: 'Αποθήκευση…',
  veSaved: 'Αποθηκευμένο',
  veUnsaved: 'Μη αποθηκευμένες αλλαγές',
  veConflict: 'Άλλαξε αλλού· ανοίξτε το ξανά',
  veSaveChanges: 'Αποθήκευση αλλαγών',
  veLeave: 'Έξοδος χωρίς αποθήκευση',
  veLeaveHint: 'Πίσω στην είδηση χωρίς τις αλλαγές αυτής της επίσκεψης· το μοντάζ, η είδηση και το video της μένουν όπως ήταν στην τελευταία αποθήκευση',
  veLeaveNothing: 'Πίσω στην είδηση· δεν υπάρχουν αλλαγές για αποθήκευση',
  veLeaveBusy: 'Η αποθήκευση έχει ήδη ξεκινήσει· περιμένετε να τελειώσει',
  veLeaveConfirm: 'Οι αλλαγές του μοντάζ δεν έχουν αποθηκευτεί και θα χαθούν. Έξοδος χωρίς αποθήκευση;',
  veDraftFound: 'Βρέθηκαν αλλαγές αυτού του μοντάζ που δεν αποθηκεύτηκαν, σε αυτόν τον browser',
  veDraftRestore: 'Επαναφορά',
  veDraftDiscard: 'Απόρριψη',
  veExportFastHint: 'Γράφει το μοντάζ σε MP4 μέσα στον browser (WebCodecs), πιο γρήγορα από τον πραγματικό χρόνο, και το αποθηκεύει στην είδηση',
  veExportSlowHint: 'Ο browser δεν έχει WebCodecs: γράφει το μοντάζ σε WebM σε πραγματικό χρόνο και το αποθηκεύει στην είδηση· κρατήστε την καρτέλα μπροστά',
  veNoRecorder: 'Ο browser δεν μπορεί να γράψει video',
  veExporting: 'Αποθήκευση',
  veExportKeep: 'Κρατήστε την καρτέλα ανοιχτή μέχρι να τελειώσει',
  veExported: 'Το αρχείο γράφτηκε και αποθηκεύτηκε στην είδηση',
  veExportFellBack: 'το γρήγορο export απέτυχε, γράφτηκε σε πραγματικό χρόνο',
  veDownload: 'Λήψη',
  veApply: 'Στο storyline',
  veApplyHint: 'Περνάει το κόψιμο και τις φάσες στο storyline της είδησης· ο player παίζει το μοντάζ',
  veApplied: 'Το μοντάζ μπήκε στο storyline της είδησης',
  veToIn: 'Στην αρχή του κοψίματος (Home)',
  veToOut: 'Στο τέλος του κοψίματος (End)',
  vePlay: 'Αναπαραγωγή (space)',
  vePause: 'Παύση (space)',
  veFrameBack: 'Ένα καρέ πίσω (←, με shift 1″)',
  veFrameFwd: 'Ένα καρέ μπροστά (→, με shift 1″)',
  veSetIn: 'IN',
  veSetInHint: 'Το κομμάτι ξεκινά από εδώ: κόβει ό,τι είναι πριν (I)',
  veSetOut: 'OUT',
  veSetOutHint: 'Το κομμάτι τελειώνει εδώ: κόβει ό,τι είναι μετά (O)',
  veAddStrap: 'Φάσα',
  veAddStrapHint: 'Νέα φάσα στο σημείο που παίζει (ή διπλό κλικ στη γραμμή T1)',
  veSnap: 'Snap',
  veSnapHint: 'Κόλλημα στα άκρα των άλλων στοιχείων όταν σέρνετε (S)',
  veZoomIn: 'Μεγέθυνση (+)',
  veZoomOut: 'Σμίκρυνση (−)',
  veFit: 'Όλο',
  veFitHint: 'Όλο το video στο πλάτος του timeline',
  veLength: 'Διάρκεια',
  veAnalysing: 'Ανάλυση του video…',
  veTrackVideo: 'Video',
  veTrackStraps: 'Φάσες',
  veTrackVo: 'Σπικάζ',
  veTrackMusic: 'Μουσική',
  veHint: 'Σύρετε clips, ήχους, μεταβάσεις και lower thirds από τα bins στις γραμμές· τα άκρα ενός κομματιού για το κόψιμο, ολόκληρο για τη θέση· C κόβει τη γραμμή που έχετε επιλέξει, Shift+C όλες· M/S σίγαση και solo κάθε γραμμής. Πλήκτρα: space, ←/→ (shift: 1″), Home/End, C, D (χαμήλωμα), T (μετάβαση), I, O, S, +/−, Delete, Ctrl+Z / Ctrl+Shift+Z.',
  veCut: 'Κόψιμο',
  veStraps: 'Φάσες',
  veVo: 'Σπικάζ',
  veMusic: 'Μουσική',
  veSound: 'Ήχος',
  veCutHint: 'Το κομμάτι που παίζει στον αέρα· το playout παίρνει τα ίδια in/out.',
  veNoStraps: 'Καμία φάσα· πατήστε ＋, διπλό κλικ στη γραμμή T1, ή πάρτε μία πρόταση από το AI.',
  veStrapEmpty: '(χωρίς κείμενο)',
  veStrapAt: 'Είσοδος',
  veStrapDur: 'Διάρκεια',
  veStrapHere: 'Στο σημείο που παίζει',
  veNoVo: 'Χωρίς σπικάζ',
  veLevel: 'Ένταση',
  veNoMusic: 'Χωρίς μουσική',
  veUploadMusic: 'Ανέβασμα',
  veDuck: 'Χαμηλώνει κάτω από το σπικάζ',
  veMusicNote: 'Μόνο μουσική που ο σταθμός έχει δικαίωμα να χρησιμοποιήσει.',
  veSourceLevel: 'Ήχος του video',
  veSoundHint: 'Η ένταση, η σίγαση (M) και το solo (S) κάθε γραμμής· ο μετρητής δίπλα στο timecode δείχνει τη στάθμη της μίξης.',
  veStatus: 'Κατάσταση',
  veStatusCut: 'Κόψιμο',
  veStatusRendered: 'Video αποθηκευμένο',
  veStatusNotRendered: 'Video μη αποθηκευμένο',
  veBinLibrary: 'Βιβλιοθήκη',
  veBinUploads: 'Εισαγωγές',
  veBinLt: 'Lower thirds',
  veBinSearch: 'Αναζήτηση clip',
  veBinEmpty: 'Κανένα clip',
  veBinAdd: 'Στο τέλος του timeline',
  veBinDrag: 'Σύρετε ένα clip στη γραμμή V1, ή πατήστε ＋ για να μπει στο τέλος.',
  veImport: 'Εισαγωγή video',
  veImportHint: 'MP4, WebM ή MOV έως 200 MB· μπαίνει στο τέλος του timeline',
  veImporting: 'Εισαγωγή…',
  veImported: 'Το αρχείο μπήκε στο timeline',
  veImportTooBig: 'Το αρχείο ξεπερνά τα 200 MB',
  veNoUploads: 'Καμία εισαγωγή ακόμη· πατήστε «Εισαγωγή video».',
  veRemoveUpload: 'Διαγραφή της εισαγωγής',
  veSplit: 'Κόψιμο',
  veSplitHint: 'Κόβει τη γραμμή που έχετε επιλέξει στο σημείο που παίζει (C)· Shift+C κόβει όλες',
  veRemovePiece: 'Αφαίρεση',
  veRemovePieceHint: 'Βγάζει το κομμάτι από το timeline (Delete)',
  vePiece: 'Κομμάτι',
  vePieceSource: 'Από',
  vePieceIn: 'IN στο clip',
  vePieceOut: 'OUT στο clip',
  vePieceHint: 'Σύρετε τα άκρα του κομματιού για το κόψιμο, ολόκληρο το κομμάτι για τη σειρά· C το κόβει στο σημείο που παίζει.',
  veMoveEarlier: 'Πιο μπροστά',
  veMoveLater: 'Πιο πίσω',
  veLt1: 'Όνομα',
  veLt2: 'Όνομα + ιδιότητα',
  veLtAdd: 'Στο σημείο που παίζει',
  veLtHint: 'Σύρετε ένα lower third στη γραμμή T1, ή πατήστε ＋· το κείμενο γράφεται δεξιά.',
  veLtDesign: 'Σχέδιο',
  veLtDesignHint: 'Το σχέδιο των lower thirds του σταθμού σε αυτό το μοντάζ: στην οθόνη, στο αρχείο και στο playout',
  veLtDesignBulletin: 'Του δελτίου',
  veLtSample1: 'ΟΝΟΜΑ ΕΠΩΝΥΜΟ',
  veLtSample2: 'ΙΔΙΟΤΗΤΑ',
  veAppliedSequence: 'Το μοντάζ συνδέθηκε με το clip της είδησης· ο player παίζει το export. Στο playout θα παίξει μόλις εισαχθεί το αρχείο (εκκρεμεί).',
  veNeedsWebCodecs: 'Μοντάζ με πολλά κομμάτια γράφεται μόνο σε browser με WebCodecs (Chrome, Edge)',
  vePieces: 'κομμάτια',
  veAirNoteSequence: 'Με πολλά κομμάτια ο αέρας είναι το αρχείο του export· εκκρεμεί η εισαγωγή του στο playout.',
  veDip: 'Χαμήλωμα μουσικής',
  veDips: 'Χαμηλώματα',
  veDipAdd: 'Χαμήλωμα εδώ',
  veDipAddHint: 'Χαμηλώνει τη μουσική για 4″ από το σημείο που παίζει (D)· σύρετε τα άκρα του για το εύρος',
  veDipNeedsMusic: 'Βάλτε πρώτα μουσική στη γραμμή A2',
  veDipLevel: 'Επίπεδο',
  veDipFrom: 'Από',
  veDipTo: 'Έως',
  veDipHint: 'Μέσα στο εύρος η μουσική πέφτει σε αυτό το ποσοστό της έντασής της, π.χ. όσο μιλά ο δημοσιογράφος μέσα στο video· όπου δύο χαμηλώματα συμπίπτουν μετρά το χαμηλότερο.',
  veNoDips: 'Κανένα χαμήλωμα· πατήστε ＋ ή D στο σημείο που παίζει, ή σύρετε ένα πάνω στη μουσική.',
  veAddAtPlayhead: 'Στο σημείο που παίζει',
  veAir: 'Για αέρα',
  veAirHint: 'Render στο playout από τα αρχεία πλήρους ποιότητας (masters)',
  veAirTitle: 'Render για τον αέρα',
  veAirIntro: 'Το playout φτιάχνει το μοντάζ από τα αρχεία πλήρους ποιότητας (MXF), δίπλα στα masters του· από εδώ φεύγουν μόνο το μοντάζ, τα γραφικά και τα αρχεία της είδησης. Όταν τελειώσει, το clip μπαίνει στη βιβλιοθήκη του playout και η είδηση παίζει αυτό.',
  veAirStart: 'Ξεκίνα render',
  veAirAgain: 'Νέο render',
  veAirCancel: 'Διακοπή',
  veAirClose: 'Κλείσιμο',
  veAirGraphics: 'Σχεδίαση γραφικών',
  veAirSending: 'Αποστολή στο playout',
  veAirPending: 'Αποστολή αρχείων',
  veAirQueued: 'Σε αναμονή στο playout',
  veAirRunning: 'Render',
  veAirDone: 'Έτοιμο στο playout',
  veAirIngesting: 'το playout ελέγχει το αρχείο…',
  veAirLinked: 'η είδηση παίζει αυτό το clip',
  veAirNotLinked: 'το clip είναι στη βιβλιοθήκη· η είδηση δεν έχει βίντεο να αντικαταστήσει',
  veAirFailed: 'Απέτυχε',
  veAirCancelled: 'Ακυρώθηκε',
  veAirStale: 'Το μοντάζ άλλαξε μετά από αυτό το render· η είδηση παίζει ξανά το αρχικό clip.',
  veAirNoPlayout: 'Δεν έχει οριστεί playout.',
  veAirBlocked: 'Το playout δεν αναπαράγει ακόμη (το export του browser μένει το αντίγραφο):',
  veAirPiece: 'Κομμάτι',
  veAirBlock_aspect: 'σχήμα άλλο από 16:9',
  'veAirBlock_video-hidden': 'κρυμμένο κανάλι V1',
  veAirBlock_look: 'χρώμα / φίλτρο',
  veAirBlock_motion: 'κίνηση (zoom / pan)',
  veAirBlock_effect: 'εφέ',
  veAirBlock_keyframes: 'keyframes πλαισίου',
  veAiEdit: 'Μοντάζ με AI',
  veAiEditHint: 'Το AI βλέπει καρέ από τα clips και το κείμενο της είδησης και φτιάχνει το μοντάζ· Ctrl+Z το αναιρεί',
  veAiIntro: 'Το AI βλέπει μερικά καρέ από κάθε clip που επιλέγετε, διαβάζει το κείμενο της είδησης και το σπικάζ, και φτιάχνει κομμάτια, μεταβάσεις, φάσες και μουσική. Το μοντάζ μπαίνει στο timeline και αναιρείται με Ctrl+Z.',
  veAiInstruction: 'Οδηγία (προαιρετικά)',
  veAiInstructionPh: 'π.χ. γρήγορος ρυθμός, ξεκίνα με το πλάνο του δορυφόρου, φάσα για τον δήμαρχο',
  veAiTarget: 'Διάρκεια',
  veAiTargetAuto: 'αυτόματα',
  veAiUseVo: 'Με το σπικάζ',
  veAiUseMusic: 'Με μουσική',
  veAiClips: 'Clips',
  veAiSearch: 'Αναζήτηση στη βιβλιοθήκη για περισσότερα clips',
  veAiInEdit: 'στο μοντάζ',
  veAiPickOne: 'Επιλέξτε τουλάχιστον ένα clip',
  veAiFrames: 'Καρέ από τα clips',
  veAiThinking: 'Το AI φτιάχνει το μοντάζ…',
  veAiGo: 'Φτιάξε το μοντάζ',
  veAiUndoNote: 'Ctrl+Z αναιρεί το μοντάζ του AI',
  veAiDone: 'Το AI έφτιαξε το μοντάζ (Ctrl+Z για αναίρεση).',
  // the editor v5: keyframes, templates, handles, the fitted layout
  veAnWipe: 'Σάρωση',
  veCopyStyle: 'Αντιγραφή στυλ',
  veDecoBar: 'Μπάρα αριστερά',
  veDecoFrame: 'Πλαίσιο',
  veDecoNone: 'Χωρίς',
  veDecoTag: 'Ετικέτα στην πρώτη γραμμή',
  veDecoUnderline: 'Γραμμή από κάτω',
  veDuplicate: 'Διπλότυπο',
  veFullscreen: 'Πλήρης οθόνη',
  veGrid: 'Πλέγμα τρίτων',
  veHandleSize: 'Σύρετε για μέγεθος',
  veHandleTurn: 'Σύρετε για περιστροφή (Shift: ανά 15°)',
  veHideTrack: 'Απόκρυψη γραμμής (δεν φαίνεται ούτε στο export)',
  veInspector: 'Ιδιότητες',
  veKeyAdd: 'Keyframe εδώ',
  veKeyAll: 'Keyframe όλων εδώ',
  veKeyAllHint: 'Keyframe για θέση, μέγεθος, περιστροφή και αδιαφάνεια στο σημείο που παίζει, ή αφαίρεσή τους (K)',
  veKeyNext: 'Στο επόμενο keyframe',
  veKeyPrev: 'Στο προηγούμενο keyframe',
  veKeyRemove: 'Αφαίρεση του keyframe',
  veKeyframes: 'keyframes',
  veLockTrack: 'Κλείδωμα γραμμής',
  veMagnetHint: 'Η κύρια γραμμή μένει χωρίς κενά: ό,τι βγαίνει, κλείνει',
  veMainSequence: 'Κύρια ακολουθία',
  veMonZoom: 'Μέγεθος οθόνης',
  vePasteStyle: 'Επικόλληση στυλ',
  vePlaceSize: 'Θέση και μέγεθος',
  vePlainTexts: 'Απλά κείμενα',
  veSafeArea: 'Ασφαλής περιοχή τίτλων',
  veShape: 'Σχήμα',
  veShowTrack: 'Εμφάνιση γραμμής',
  veSplitterHint: 'Σύρετε για ψηλότερο ή χαμηλότερο timeline',
  veStyleCopied: 'Το στυλ αντιγράφηκε· Ctrl+V σε άλλο ίδιου είδους',
  veTemplates: 'Templates',
  veTime: 'Χρόνος',
  veTools: 'Εργαλεία',
  veTplBreaking: 'Έκτακτη είδηση',
  veTplBreakingSample: 'ΕΚΤΑΚΤΟ\nΓράψτε τον τίτλο της είδησης',
  veTplFigure: 'Αριθμός',
  veTplFigureSample: '00%\nτι μετράει ο αριθμός',
  veTplHeadline: 'Τίτλος social',
  veTplHeadlineSample: 'Ο τίτλος σας εδώ',
  veTplLive: 'Ζωντανά',
  veTplLiveSample: '● ΖΩΝΤΑΝΑ',
  veTplLocation: 'Τοποθεσία',
  veTplLocationSample: 'ΤΟΠΟΘΕΣΙΑ',
  veTplName: 'Όνομα και ιδιότητα',
  veTplNameSample: 'Ονοματεπώνυμο\nΙδιότητα',
  veTplQuote: 'Κάρτα δήλωσης',
  veTplQuoteSample: '«Η δήλωση εδώ»\nΠοιος τη λέει',
  veTplSection: 'Τίτλος ενότητας',
  veTplSectionSample: 'ΕΝΟΤΗΤΑ',
  veTxAccent: 'Χρώμα διακόσμησης',
  veTxDeco: 'Διακόσμηση',
  veTxDesign: 'Σχέδιο',
  veTxLinesHint: 'Η πρώτη γραμμή είναι ο τίτλος· οι επόμενες (Enter) γίνονται μικρότερες με τη «Δεύτερη γραμμή».',
  veTxSecond: 'Δεύτερη γραμμή',
  veUnlockTrack: 'Ξεκλείδωμα γραμμής',
  // the editor v4: texts, photos, looks, frame, speed, effects, format
  veAddOverlay: 'Πάνω από το video (V2), στο σημείο που παίζει',
  veAddPhotoPiece: 'Ως κομμάτι στη V1, στο σημείο που παίζει',
  veAddText: 'Κείμενο',
  veAnFade: 'Σβήσιμο',
  veAnIn: 'Είσοδος',
  veAnLength: 'Διάρκεια κίνησης',
  veAnNone: 'Καμία',
  veAnOut: 'Έξοδος',
  veAnPop: 'Αναπήδηση',
  veAnSlideDown: 'Προς τα κάτω',
  veAnSlideLeft: 'Από δεξιά',
  veAnSlideRight: 'Προς τα δεξιά',
  veAnSlideUp: 'Από κάτω',
  veAnType: 'Γραφομηχανή',
  veAnimation: 'Εμφάνιση και εξαφάνιση',
  veAspectPortrait: 'Πορτρέτο · Instagram',
  veAspectSquare: 'Τετράγωνο · feed',
  veAspectTall: 'Κάθετο · Reels, TikTok, Stories',
  veAspectWide: 'Οριζόντιο · TV, YouTube',
  veAutoCaptions: 'Υπότιτλοι από το σπικάζ',
  veAutoCaptionsHint: 'Από το κείμενο κάθε σπικάζ στη A1, μοιρασμένο στη διάρκειά του κατά το μήκος των φράσεων (όχι αναγνώριση ομιλίας)· όσοι έγιναν πριν αντικαθίστανται.',
  veBackground: 'Φόντο',
  veBgBlack: 'Μαύρο',
  veBgBlur: 'Θολό από την ίδια εικόνα',
  veBgColor: 'Χρώμα',
  veBinEffects: 'Εφέ',
  veBinFilters: 'Φίλτρα',
  veBinFormat: 'Μορφή',
  veBinImages: 'Φωτογραφίες',
  veBinText: 'Κείμενο',
  veCaption: 'Υπότιτλος',
  veCaptionStyleAll: 'Το ίδιο στυλ σε όλους',
  veCaptionStyleAllHint: 'Όλοι οι υπότιτλοι παίρνουν τη γραμματοσειρά, τα χρώματα, τη θέση και την κίνηση αυτού',
  veCaptions: 'Υπότιτλοι',
  veCaptionsMade: 'υπότιτλοι από το σπικάζ (Ctrl+Z για αναίρεση)',
  veClearCaptions: 'Αφαίρεση υποτίτλων',
  veDragOnMonitor: 'Σύρετέ το και πάνω στην οθόνη για να το μετακινήσετε.',
  veEffectAddHint: 'Στο επιλεγμένο κομμάτι (ή σε όποιο παίζει)· ή σύρετέ το σε ένα κομμάτι',
  veEffectsHint: 'Πατήστε ένα εφέ για το επιλεγμένο κομμάτι, ή σύρετέ το σε ένα κομμάτι της V1 ή στην οθόνη. Η ένταση στον επιθεωρητή (Εφέ).',
  veFiltersHint: 'Πατήστε ένα φίλτρο για το επιλεγμένο κομμάτι (ή όποιο παίζει) ή σύρετέ το σε ένα κομμάτι. Ένταση και ρυθμίσεις χρώματος στον επιθεωρητή (Χρώμα).',
  veFitContain: 'Ολόκληρη η εικόνα',
  veFitCover: 'Γεμίζει το κάδρο (κόβει)',
  veFlBw: 'Ασπρόμαυρο',
  veFlCinematic: 'Κινηματογραφικό',
  veFlCool: 'Ψυχρό',
  veFlDramatic: 'Δραματικό',
  veFlFade: 'Ξεθωριασμένο',
  veFlNoir: 'Noir',
  veFlNone: 'Κανένα',
  veFlVintage: 'Vintage',
  veFlVivid: 'Ζωντανό',
  veFlWarm: 'Ζεστό',
  veFontCondensed: 'Στενή',
  veFontDisplay: 'Έντονη',
  veFontMono: 'Μονόχωρη',
  veFontSans: 'Sans',
  veFontSerif: 'Serif',
  veFormatNote: 'Το playout παίζει μόνο 16:9· οι άλλες μορφές είναι για τα social.',
  veFps: 'Καρέ/δευτ.',
  veFrBottom: 'Κάτω',
  veFrCrop: 'Κόψιμο κάδρου',
  veFrFlipH: 'Καθρέφτης',
  veFrFlipV: 'Ανάποδα',
  veFrLeft: 'Αριστερά',
  veFrOpacity: 'Αδιαφάνεια',
  veFrRight: 'Δεξιά',
  veFrRotation: 'Περιστροφή',
  veFrScale: 'Μέγεθος',
  veFrTop: 'Πάνω',
  veFrX: 'Οριζόντια',
  veFrY: 'Κάθετα',
  veFreeze: 'Πάγωμα καρέ',
  veFreezeFrame: 'Παγωμένο καρέ',
  veFreezeHint: 'Το καρέ στο σημείο που παίζει μένει 2″ ανάμεσα στα δύο μισά του κομματιού (F)',
  veFreezeNone: 'Εδώ παίζει ήδη ακίνητη εικόνα',
  veFxBars: 'Κινηματογραφικές μπάρες',
  veFxFlash: 'Φλας',
  veFxGlitch: 'Glitch',
  veFxGrain: 'Κόκκος',
  veFxHint: 'Το φλας ανάβει στην αρχή του κομματιού· τα άλλα κρατούν όσο το κομμάτι.',
  veFxShake: 'Κούνημα',
  veImageImported: 'Η φωτογραφία ανέβηκε· σύρετέ τη στη V1 ή στη V2.',
  veImageTooBig: 'Η φωτογραφία ξεπερνά τα 15 MB',
  veImagesHint: 'Σύρετε μια φωτογραφία στη V1 για κομμάτι, ή στη V2 (ή στην οθόνη) για να μπει πάνω από το video: λογότυπο, χάρτης, πορτρέτο.',
  veImportPhoto: 'Ανέβασμα φωτογραφίας',
  veLkAdjust: 'Ρυθμίσεις',
  veLkAmount: 'Ένταση',
  veLkBlur: 'Θόλωμα',
  veLkBrightness: 'Φωτεινότητα',
  veLkContrast: 'Αντίθεση',
  veLkSaturation: 'Κορεσμός',
  veLkTemperature: 'Θερμοκρασία',
  veLkVignette: 'Βινιέτα',
  veMoAmount: 'Πόσο',
  veMoNone: 'Καμία',
  veMoPanDown: 'Πανοραμίκ κάτω',
  veMoPanLeft: 'Πανοραμίκ αριστερά',
  veMoPanRight: 'Πανοραμίκ δεξιά',
  veMoPanUp: 'Πανοραμίκ πάνω',
  veMoZoomIn: 'Ζουμ μέσα',
  veMoZoomOut: 'Ζουμ έξω',
  veMotion: 'Κίνηση κάμερας (Ken Burns)',
  veNoCanvasFilters: 'Αυτός ο browser δεν εφαρμόζει φίλτρα στον καμβά: εδώ και στο export του φαίνονται μόνο οι αποχρώσεις και η βινιέτα. Κάντε το μοντάζ σε Chrome ή Edge.',
  veNoCaptions: 'Δεν βρέθηκε σπικάζ με κείμενο στη A1',
  veNoImages: 'Καμία φωτογραφία ακόμη',
  veNoOverlays: 'Τίποτα πάνω από το video ακόμη',
  veNoTexts: 'Κανένα κείμενο ακόμη',
  veOutput: 'Export',
  veOvWidth: 'Πλάτος',
  veOverlaysCount: 'εικόνες πάνω',
  veReset: 'Επαναφορά',
  veResolution: 'Ανάλυση',
  veSpeed: 'Ταχύτητα',
  veSpeedFrozen: 'Ένα παγωμένο καρέ δεν έχει ταχύτητα· η διάρκειά του αλλάζει στα Βασικά ή τραβώντας το άκρο του.',
  veSpeedHint: 'ο ήχος του κομματιού ακολουθεί (και ο τόνος του)',
  veSpeedLength: 'Διάρκεια:',
  veSpeedPhoto: 'Μια φωτογραφία δεν έχει ταχύτητα· η διάρκειά της αλλάζει στα Βασικά ή τραβώντας το άκρο της.',
  veSpotsHint: 'Γρήγορη θέση στο κάδρο',
  veTabBasic: 'Βασικά',
  veTabColor: 'Χρώμα',
  veTabEffects: 'Εφέ',
  veTabFrame: 'Κάδρο',
  veTabSpeed: 'Ταχύτητα',
  veText: 'Κείμενο',
  veTextAddHint: 'Στο σημείο που παίζει (T2)· ή σύρετέ το στη γραμμή T2 ή στην οθόνη',
  veTextBinHint: 'Πατήστε ένα στυλ για κείμενο στο σημείο που παίζει, ή σύρετέ το στη T2. Γράψτε τις λέξεις στον επιθεωρητή και σύρετε το κείμενο στην οθόνη.',
  veTextsCount: 'κείμενα',
  veTrackOverlay: 'Εικόνες',
  veTrackText: 'Κείμενα',
  veTxBold: 'Έντονα',
  veTxBox: 'Πλαίσιο',
  veTxBoxOpacity: 'Αδιαφάνεια πλαισίου',
  veTxBreaking: 'Έκτακτο',
  veTxBreakingSample: 'ΕΚΤΑΚΤΟ',
  veTxCaption: 'Υπότιτλος',
  veTxCaptionSample: 'Υπότιτλος',
  veTxCenter: 'Στο κέντρο',
  veTxColor: 'Χρώμα',
  veTxCredit: 'Πηγή',
  veTxCreditSample: 'Πηγή',
  veTxFont: 'Γραμματοσειρά',
  veTxItalic: 'Πλάγια',
  veTxLeft: 'Αριστερά',
  veTxLocation: 'Τοποθεσία',
  veTxLocationSample: 'ΤΟΠΟΘΕΣΙΑ',
  veTxOutline: 'Περίγραμμα',
  veTxPlace: 'Θέση',
  veTxPlaceholder: 'Γράψτε το κείμενο (Enter για νέα γραμμή)',
  veTxQuote: 'Δήλωση',
  veTxQuoteSample: '«Η δήλωση»',
  veTxRight: 'Δεξιά',
  veTxShadow: 'Σκιά',
  veTxSize: 'Μέγεθος',
  veTxSocial: 'Social',
  veTxSocialSample: 'Δείτε τι έγινε',
  veTxSubtitle: 'Δεύτερη γραμμή',
  veTxSubtitleSample: 'Δεύτερη γραμμή',
  veTxTitle: 'Τίτλος',
  veTxTitleSample: 'ΤΙΤΛΟΣ',
  veTxUpper: 'Κεφαλαία',
  veTxWidth: 'Πλάτος',
  veWaiting: 'Φόρτωση εικόνας…',
  veAudioBinHint: 'Σύρετε ένα σπικάζ στη γραμμή A1 ή μια μουσική στην A2, ή πατήστε ＋ για το σημείο που παίζει.',
  veAudioIn: 'Από',
  veAudioOut: 'Έως',
  veBeds: 'Μουσικές',
  veBinAudio: 'Ήχος',
  veBinTransitions: 'Μεταβάσεις',
  veCutHere: 'Κόψιμο εδώ',
  veDuckLevel: 'Πόσο χαμηλώνει',
  veEndFade: 'Fade στο τέλος',
  veEndFadeHint: 'Το τέλος σβήνει σε μαύρο',
  veEndFadeNone: 'Χωρίς fade στο τέλος',
  veEndFadeBlack: 'Σε μαύρο',
  veEndFadeWhite: 'Σε λευκό',
  veFadeFromBlack: 'Από μαύρο',
  veFadeFromWhite: 'Από λευκό',
  veFadeIn: 'Fade in',
  veFadeOut: 'Fade out',
  veMeter: 'Στάθμη ήχου (αριστερό / δεξί)',
  veMixer: 'Μίκτης',
  veMusicClipHint: 'Η μουσική χαμηλώνει μόνη της κάτω από το σπικάζ (A2) και στα χαμηλώματα· C την κόβει στο σημείο που παίζει.',
  veVoClipHint: 'Σύρετε τα άκρα για το κόψιμο, ολόκληρο για τη θέση· C το κόβει στο σημείο που παίζει· η μουσική χαμηλώνει από κάτω.',
  veMute: 'Σίγαση γραμμής',
  veSolo: 'Μόνο αυτή η γραμμή',
  veNewTake: 'Νέο σπικάζ',
  veNoBeds: 'Καμία μουσική· ανεβάστε ένα αρχείο.',
  veNormalise: 'Κανονικοποίηση',
  veNormaliseHint: 'Φέρνει την πιο δυνατή κορυφή του κομματιού στο −1 dB',
  veNormaliseWait: 'Ο ήχος φορτώνει ακόμη· δοκιμάστε σε λίγο',
  veNothingToCut: 'Τίποτα δεν παίζει σε αυτή τη γραμμή στο σημείο αυτό',
  vePieceSound: 'Ήχος κομματιού',
  veTrackSound: 'Ήχος πλάνων',
  veSoundDetach: 'Διαχωρισμός ήχου',
  veSoundDetachHint: 'Διαχωρισμός ήχου από την εικόνα: ο ήχος του κομματιού πηγαίνει στη γραμμή A3, για να μετακινηθεί, να κοπεί ή να σβηστεί χωριστά',
  veSoundRelink: 'Επανασύνδεση ήχου',
  veSoundRelinkHint: 'Ο ήχος επιστρέφει στο κομμάτι του (τα κομμάτια του στο A3 φεύγουν)',
  veSoundOnA3: 'στο A3, χωριστά από την εικόνα',
  veSoundDetached: 'Ο ήχος είναι πλέον στο A3: μετακινήστε, κόψτε ή σβήστε τον χωριστά από την εικόνα',
  veSoundRelinked: 'Ο ήχος επέστρεψε στο κομμάτι του',
  veSoundPickPiece: 'Επιλέξτε ένα κομμάτι στο V1 για να διαχωρίσετε τον ήχο του',
  veSoundNone: 'Αυτό το κομμάτι δεν έχει ήχο (φωτογραφία ή ακίνητη εικόνα)',
  veSoundSpeed: 'Ο ήχος διαχωρίζεται μόνο σε κανονική ταχύτητα (1×)',
  veSoundClipHint: 'Ο ήχος ενός κομματιού, χωριστά από την εικόνα του: σύρετε τα άκρα για το κόψιμο, ολόκληρο για τη θέση· C τον κόβει, Delete τον σβήνει· «Επανασύνδεση ήχου» (L) τον επιστρέφει στο κομμάτι.',
  veSoundTrackHint: 'Εδώ μπαίνει ο ήχος των κομματιών που χωρίζετε από την εικόνα: επιλέξτε ένα κομμάτι στο V1 και πατήστε ✂♪ ή L.',
  veSoundNoClips: 'Κανένας ήχος χωρισμένος από την εικόνα ακόμη.',
  veUndo: 'Αναίρεση (Ctrl+Z)',
  veRedo: 'Επανάληψη (Ctrl+Shift+Z)',
  veSplitAll: 'Όλες οι γραμμές',
  veSplitAllHint: 'Κόβει όλες τις γραμμές στο σημείο που παίζει (Shift+C)',
  veTakes: 'Σπικάζ της είδησης',
  veTrAddHint: 'Στο κόψιμο πιο κοντά στο σημείο που παίζει (T)',
  veTrCut: 'Κοφτό (χωρίς μετάβαση)',
  veTrDefault: '0,6″ · σύρετέ τη σε ένα κόψιμο',
  veTrDissolve: 'Dissolve',
  veTrDipBlack: 'Μέσα από μαύρο',
  veTrDipWhite: 'Μέσα από λευκό',
  veTrWipe: 'Wipe',
  veTrPush: 'Push',
  veTrFirst: 'Αρχή',
  veTrFromPrev: 'Μετάβαση από το προηγούμενο',
  veTrHint: 'Σύρετε μια μετάβαση σε ένα κόψιμο της γραμμής V1, ή πατήστε ＋ για το κόψιμο πιο κοντά στο σημείο που παίζει.',
  veTrNoneFirst: 'Χωρίς fade στην αρχή',
  veTransitions: 'μεταβάσεις',
  veAirNote: 'Στον αέρα το playout παίζει το video με το κόψιμο και τις φάσες ως CG· σπικάζ και μουσική ακούγονται μόνο στο αρχείο του export (εκκρεμεί η εισαγωγή στο playout).',
  slEdit: 'Μοντάζ',
  slEditOpen: 'Άνοιγμα μοντάζ',
  slEditHint: 'Κόψιμο, φάσες, σπικάζ και μουσική σε timeline',
  slEditRendered: 'μοντάζ · render ✓',
  slEditDraft: 'μοντάζ',
  hubOpenEditor: 'Μοντάζ στο timeline',
  hubOpenEditorHint: 'Κόψιμο, φάσες, σπικάζ και μουσική στο timeline, σε δική του σελίδα',
  hubMusic: 'Μουσική',
  hubMusicStub: 'Μουσική: δεν υπάρχει ακόμη βιβλιοθήκη με άδεια χρήσης (εκκρεμεί)',
  hubRender: 'Render',
  hubRenderStub: 'Render: το clip παίζει όπως είναι από το playout· μίξη/export δεν έχει ρυθμιστεί (εκκρεμεί)',
  videosMenuSearch: 'Αναζήτηση Video',
  videosMenuNew: 'Νέο Video',
  videosSearchTitle: 'Αναζήτηση στο Αρχείο Θεμάτων Video',
  videosHint: 'Η Διάρκεια υπολογίζεται από τα TC τέλους και αρχής. Πατήστε στον Τύπο ή στον Τίτλο για την καρτέλα του θέματος.',
  videoDetails: 'Στοιχεία Θέματος Video',
  videoNew: 'Νέο Θέμα Video',
  videoEdit: 'Τροποποίηση Θέματος Video',
  videoType: 'Τύπος',
  anyType: '< Επιλέξτε Τύπο >',
  tapeNo: 'Α/Α Ταινίας',
  itemNo: 'Α/Α Θέματος',
  eventDate: 'Ημερομηνία Συμβάντος',
  tcIn: 'TC αρχής',
  tcOut: 'TC τέλους',
  videoDuration: 'Διάρκεια',
  videoSummary: 'Περίληψη',
  videoCategories: 'Κατηγορίες',
  videosNone: 'Δεν βρέθηκαν θέματα video',
  videosCount: 'θέματα video',
  viewStandard: 'Τυπική εμφάνιση',
  viewShort: 'Με ελάχιστη περίληψη',
  viewFull: 'Με πλήρη περίληψη',
  confirmDeleteVideo: 'Να διαγραφεί το θέμα video; Παραμένει στο ιστορικό.',
  videoConflict: 'Το θέμα video τροποποιήθηκε από άλλον χρήστη. Εμφανίζεται η τρέχουσα έκδοση· ξαναπεράστε τις αλλαγές σας.',
  videoSaved: 'Το θέμα video αποθηκεύτηκε',
  tcFormat: 'ΩΩ:ΛΛ:ΔΔ',
  // playout media linking
  colMedia: 'Video (Playout)',
  mediaDialogTitle: 'Σύνδεση video από το Playout',
  mediaSearch: 'Αναζήτηση στη βιβλιοθήκη του playout',
  mediaNone: 'Δεν βρέθηκαν clips',
  mediaCurrent: 'Τρέχον video',
  mediaAssign: 'Σύνδεση',
  mediaClear: 'Αφαίρεση video',
  mediaHint: 'Μόνο γραμμές με συνδεδεμένο video στέλνονται στον player. Η αλλαγή σειράς και οι αφαιρέσεις περνούν αυτόματα, ποτέ στο θέμα που είναι στον αέρα.',
  playoutPlayer: 'Player',
  playoutOnAir: 'στον αέρα',
  // the story's video: a clip, or a virtual code until the clip exists
  storyVideo: 'ΒΙΝΤΕΟ',
  storyVideoNone: 'Δεν έχει οριστεί video',
  storyVideoChoose: 'Επιλογή video',
  storyVideoVirtual: 'Εικονικό video',
  storyVideoVirtualHint: 'Κρατά έναν κωδικό μέχρι να είναι έτοιμο το clip. Ονομάστε το αρχείο με τον κωδικό (π.χ. V-261026-017_neoklis.mxf) και, μόλις φτάσει στη βιβλιοθήκη του playout, μπαίνει μόνο του στη θέση του κωδικού σε όλα τα δελτία.',
  storyVideoRemove: 'Αφαίρεση',
  storyVideoSaveFirst: 'Αποθηκεύστε πρώτα την είδηση για να ορίσετε video',
  storyVideoRows: 'γραμμές δελτίου ενημερώθηκαν',
  storyVideoCode: 'Κωδικός',
  storyVideoExpected: 'αναμενόμενη διάρκεια',
  virtualWaiting: 'Εικονικό video· αναμονή για το αρχείο με αυτόν τον κωδικό',
  virtualBadge: 'εικονικό',
  virtualReplaced: 'Το εικονικό video αντικαταστάθηκε από το αρχείο',
  copyCode: 'Αντιγραφή κωδικού',
  // the storyboard: cues of the story in playing order
  storyboard: 'Storyboard',
  storyboardHint: 'Τα cues της είδησης με τη σειρά που παίζουν: video (clip ή εικονικός κωδικός) και τίτλοι CG. Γράψτε ΒΙΝΤΕΟ ΜΕ ΗΧΟ, ΤΙΤΛΟΣ 1, ΦΑΣΑ ή ΡΕΠΟΡΤΑΖ στο κείμενο και ορίστε το cue από κάτω.',
  storyboardEmpty: 'Κανένα cue ακόμη. Γράψτε ΒΙΝΤΕΟ ΜΕ ΗΧΟ ή ΤΙΤΛΟΣ 1 στο κείμενο και ορίστε το cue από κάτω, ή προσθέστε από εδώ.',
  storyboardSaved: 'αποθηκεύτηκε',
  cueAddVideo: 'Video',
  cueAddCg: 'Τίτλος CG',
  cuePreview: 'Προεπισκόπηση',
  cuePreviewEdit: 'το μοντάζ, όπως στον editor',
  cuePreviewCut: 'το κομμάτι του μοντάζ· οι τίτλοι του μπαίνουν από το CG',
  cuePreviewNoExport: 'το μοντάζ δεν έχει export ακόμη· παίζει το αρχικό clip',
  cueEdit: 'Επεξεργασία',
  cueTemplate: 'Τύπος τίτλου',
  cueDurationS: 'Διάρκεια στον αέρα (δευτερόλεπτα)',
  cueLine: 'Γραμμή',
  cueNoPreview: 'Το playout δεν έχει προεπισκόπηση για αυτό το clip',
  cueOrphan: 'Η επικεφαλίδα του cue δεν υπάρχει πια στο κείμενο',
  cueManual: 'χωρίς θέση στο κείμενο· παίζει μετά τα υπόλοιπα',
  cueTotal: 'συνολική διάρκεια video',
  cuePlaylistHint: 'Η λίστα κάθε δελτίου είναι διαθέσιμη στον αυτοματισμό: GET /api/rundowns/:id/playlist',
  // media side panel of the rundown
  mediaPanel: 'Μέσα',
  mediaPanelNoRow: 'Επιλέξτε γραμμή του δελτίου',
  mediaPanelNoStory: 'Η γραμμή δεν έχει είδηση· video συνδέεται μόνο σε ειδήσεις',
  mediaToPlayout: 'PLAYOUT',
  mediaOnRow: 'στη γραμμή',
  graphicsAdd: 'Προσθήκη / επεξεργασία γραφικών',
  graphicsNotReported: 'χωρίς αναφορά',
  storyText: 'Κείμενο',
  close: 'Κλείσιμο',
  edit: 'Τροποποίηση',
  noPermission: 'Δεν έχετε δικαίωμα για αυτή τη σελίδα',
  // incoming feeds
  tabFeeds: 'Feeds',
  feedsMenu: 'Feeds',
  feedsTitle: 'Feeds',
  feedsHint: 'Τι μεταδίδουν οι πηγές που παρακολουθεί το τμήμα (RSS / Atom). Κλικ σε θέμα για περίληψη και "Νέα Είδηση" με προσυμπληρωμένο τίτλο, κείμενο και πηγή.',
  feedsAll: 'Όλες',
  feedsOther: 'Λοιπές',
  feedsNoSources: 'Δεν έχουν οριστεί feeds· ο διαχειριστής τα προσθέτει στη Διαχείριση → Feeds.',
  feedsEmpty: 'Δεν υπάρχουν θέματα για αυτή την επιλογή',
  feedsNewStory: 'Νέα Είδηση από αυτό',
  feedsOpenSource: 'Άνοιγμα πηγής',
  feedRead: 'Ανάγνωση',
  feedReading: 'Διαβάζεται το πλήρες κείμενο…',
  feedNoFullText: 'Το πλήρες κείμενο δεν δόθηκε ούτε από τη ροή ούτε από τη σελίδα· ανοίξτε την πηγή.',
  feedsAp: 'Associated Press',
  feedsApNotConfigured: 'δεν είναι συνδεδεμένο. Το AP δεν δίνει δημόσιο RSS· χρειάζεται το κλειδί AP Media API του σταθμού (μεταβλητή AP_MEDIA_API_KEY στον διακομιστή).',
  feedsApFeeds: 'ροές διαθέσιμες στο πλάνο του σταθμού· βρίσκονται στις Προτεινόμενες της Νέας ροής.',
  feedsApError: 'δεν απάντησε',
  feedsMore: 'Παλαιότερα',
  feedsSourceLine: 'Πηγή',
  justNow: 'τώρα',
  feedsAdminTitle: 'Feeds',
  feedsAdminHint: 'Οι πηγές RSS / Atom που διαβάζει το σύστημα, κάθε πόσα λεπτά, και αν η τελευταία ανάγνωση πέτυχε. Τα θέματα κρατούνται έναν μήνα.',
  feedsAdminTip: 'Προτεινόμενες πηγές: όσες απάντησαν με έγκυρη ροή στον έλεγχο της 26/10/2026. Κάθε διεύθυνση ελέγχεται με Προεπισκόπηση πριν αποθηκευτεί.',
  feedsNew: 'Νέα ροή',
  feedsEdit: 'Τροποποίηση ροής',
  feedsName: 'Όνομα',
  feedsGroup: 'Ομάδα',
  feedsInterval: 'Κάθε',
  feedsLastRead: 'Τελευταία ανάγνωση',
  feedsItems: 'Θέματα',
  feedsError: 'σφάλμα',
  feedsFetchNow: 'Ανάγνωση τώρα',
  feedsPause: 'Παύση',
  feedsResume: 'Συνέχιση',
  feedsDeleteConfirm: 'Να διαγραφεί η ροή και τα θέματά της;',
  feedsSuggested: 'Προτεινόμενη',
  feedsPreview: 'Προεπισκόπηση',
  feedsNewItems: 'νέα θέματα',
  feedsInFeed: 'στη ροή',
  minutes: 'λεπτά',
  feedsAgent: 'Ταυτότητα αιτήματος',
  feedsAgentBrowser: 'ως browser (για πηγές που απορρίπτουν feed readers, π.χ. ΓΤΠ)',
  feedsAgentHint: 'Κανονικά το σύστημα δηλώνει ότι είναι ο feed reader του AirPost. Κάποια firewall (gov.cy) δέχονται μόνο browsers.',
  // producer's playout console
  controlTitle: 'ΕΛΕΓΧΟΣ PLAYOUT',
  controlShort: 'Playout',
  controlHint: 'Σύρετε τις γραμμές στη σειρά μετάδοσης· κάθε αλλαγή σειράς ή clip φτάνει αμέσως στον player. Η γραμμή στον αέρα και η επόμενη προστατεύονται.',
  relay: 'σύνδεσμος',
  publishManage: 'Playout / Δημοσίευση',
  publishLink: 'Σύνδεση με playout',
  onAir: 'Στον αέρα',
  nextUp: 'Επόμενο',
  dragToReorder: 'Σύρετε για αλλαγή σειράς (ή Alt+↑/↓)',
  noClip: 'χωρίς video',
  menu: 'Μενού',
  holdToReorder: 'Κρατήστε πατημένο ένα θέμα και σύρετέ το για αλλαγή σειράς',
  moveUp: 'Πάνω',
  moveDown: 'Κάτω',
  linkedHere: 'συνδεδεμένο',
  // control room board
  crTitle: 'Control Room',
  crPickHint: 'Ο πίνακας του control room για ένα δελτίο: μεγάλα γράμματα για την οθόνη του θαλάμου, στον αέρα / επόμενο, χρόνοι, και αλλαγή σειράς με ένα κουμπί ή με σύρσιμο.',
  crNoBulletins: 'Δεν έχει ανοίξει δελτίο για σήμερα.',
  crOtherDay: 'Άλλη ημέρα',
  crPrevDay: 'Προηγούμενη ημέρα',
  crNextDay: 'Επόμενη ημέρα',
  crYesterday: 'Χθες',
  crOtherIsToday: 'Τα σημερινά δελτία είναι πιο πάνω. Διαλέξτε άλλη ημερομηνία για παλαιότερο ή επόμενο δελτίο.',
  crNoBulletinsOn: 'Δεν υπάρχει δελτίο στις',
  crLoad: 'Φόρτωση στο Control',
  crNotLoaded: 'Ο οδηγός δεν έχει φορτωθεί στο playout',
  crAutocueEmpty: 'Το autocue είναι άδειο (εκφόρτωση)',
  crLoadHint: 'Τα video του δελτίου μπαίνουν στη λίστα του player με τη σειρά του οδηγού· ό,τι άλλο έχει ο player φεύγει, εκτός από αυτό που παίζει.',
  crLoadTitle: 'Φόρτωση δελτίου στο playout',
  crLoadNote: 'Τα video του δελτίου φορτώνονται στον player με τη σειρά του οδηγού και ό,τι άλλο υπάρχει στη λίστα του player αφαιρείται. Κλιπ που παίζει εκείνη τη στιγμή δεν αγγίζεται· κλιπ σε παύση ή σταματημένο σταματά και αφαιρείται κι αυτό. Από εκεί και πέρα κάθε αλλαγή σειράς ή video στον οδηγό περνά μόνη της.',
  crLoadPlayer: 'Player',
  crLoadGo: 'Φόρτωση',
  crLoadSent: 'Στάλθηκε στο playout· η λίστα του player ενημερώνεται σε λίγα δευτερόλεπτα.',
  crNoPlayers: 'Δεν βρέθηκε player στο playout. Είναι το relay συνδεδεμένο; (Διαχείριση → Playout / MOS)',
  // the storyline: the script as boxes
  slStoryline: 'Storyline',
  slText: 'Κείμενο',
  slTextHint: 'Το κείμενο όπως είναι (ελεύθερη γραφή)',
  slHint: 'Η είδηση ως playlist: κάθε κουτί είναι ένα βήμα (ON, βίντεο, τίτλος, δήλωση, ρεπορτάζ…). Το κείμενο του autocue, οι χρόνοι και οι εξαγωγές παράγονται από τα κουτιά. Σύρετε τα κουτιά από την κεφαλίδα τους για να αλλάξετε σειρά, και το μενού μέσα στη λίστα για να προσθέσετε.',
  slEmpty: 'Κενή είδηση. Προσθέστε το πρώτο κουτί από το μενού αριστερά, ή σύρετέ το εδώ.',
  slAdd: 'Προσθήκη',
  slAfterBox: 'Μπαίνει μετά το κουτί',
  slAtEnd: 'Μπαίνει στο τέλος',
  slInsertAfter: 'Προσθήκη από κάτω',
  slDragMenu: 'Ή σύρετέ το στη θέση που θέλετε',
  slDragBox: 'Σύρετε από την κεφαλίδα για να αλλάξετε θέση',
  slDropHere: 'Αφήστε το εδώ',
  cueDragManual: 'Σύρετε για να αλλάξετε τη σειρά των χειροκίνητων cue',
  slRead: 'Παρουσιαστής',
  slVo: 'Σπικάζ',
  slSoundVideoHint: 'Βίντεο με τον ήχο του· στο playout παίζει από τον player του δελτίου',
  slVoVideoHint: 'Εικόνες χωρίς ήχο· ο παρουσιαστής μιλάει από πάνω. Στο playout παίζει από τον player VO',
  voPlayerTag: 'player VO',
  crLoadVoPlayer: 'Player VO',
  crLoadVoHint: 'Ο player όπου φορτώνονται τα ΒΙΝΤΕΟ VO (εικόνες χωρίς ήχο) του δελτίου· τα βίντεο με ήχο πάνε στον Player',
  crLoadVoNone: 'Κανένας: τα VO στον ίδιο player',
  crLoadVoUsual: 'συνήθης',
  crLoadVoSame: 'Τα VO θα παίξουν στον ίδιο player με τα βίντεο με ήχο.',
  slpTitle: 'Στον αέρα',
  slpPreview: 'PREVIEW',
  slpOnAir: 'ON AIR',
  slpStudio: 'ΣΤΟΥΝΤΙΟ',
  slpNoClip: 'Χωρίς clip ακόμη',
  slpNoPreview: 'Το playout δεν έχει προεπισκόπηση για αυτό το clip',
  slpEmpty: 'Προσθέστε κουτιά για να δείτε το θέμα όπως θα βγει στον αέρα',
  slpPlay: 'Αναπαραγωγή (space)',
  slpPause: 'Παύση (space)',
  slpStop: 'Από την αρχή (Home)',
  slpPrev: 'Προηγούμενο κουτί (←)',
  slpNext: 'Επόμενο κουτί (→)',
  slpHint: 'Τα video παίζουν από το playout, τα κείμενα στον ρυθμό ανάγνωσης (3,3 λέξεις/δευτ.), οι τίτλοι και οι κάρτες όσο ορίζει η φάσα τους· ένας τίτλος μέσα σε βίντεο μπαίνει στο δευτερόλεπτό του· ένα ΒΙΝΤΕΟ VO μέσα σε ON παίζει σε παράθυρο δίπλα στον παρουσιαστή.',
  slpPip: 'ΒΙΝΤΕΟ VO μέσα στο ON: παίζει σε παράθυρο όσο μιλά ο παρουσιαστής',
  slAt: 'στο',
  slAtHint: 'Το δευτερόλεπτο του κουτιού που προηγείται στο οποίο μπαίνει αυτό το κουτί',
  slAttach: 'Μέσα στο βίντεο',
  slAttachPrev: 'Πάνω στο προηγούμενο',
  slAttachHint: 'Το κουτί μπαίνει μέσα στο κουτί που προηγείται, στο δευτερόλεπτο που ορίζετε, χωρίς δικό του χρόνο (ένα βίντεο παίρνει την εικόνα για τη διάρκειά του)',
  slDetach: 'Μετά',
  slDetachHint: 'Το κουτί γίνεται ξανά δικό του βήμα, μετά το κουτί που προηγείται',
  slInside: 'Μέσα στο',
  slInsideAdd: 'μέσα',
  slInsideAddHint: 'Προσθήκη κουτιού μέσα σε αυτό (τίτλος, βίντεο, κάρτα, ON…), στο επόμενο ελεύθερο δευτερόλεπτο· σύρετε επίσης ένα κουτί πάνω του',
  slDropInto: 'Αφήστε τον τίτλο μέσα στο κουτί για να εμφανιστεί πάνω στις εικόνες του',
  slModeOnHint: 'Ο παρουσιαστής το διαβάζει στο στούντιο (autocue)',
  slModeVoHint: 'Διαβάζεται πάνω στις εικόνες (σπικάζ)',
  slReadPh: 'Το κείμενο που διαβάζει ο παρουσιαστής…',
  slVoPh: 'Το σπικάζ πάνω στις εικόνες…',
  slNoClip: 'Χωρίς clip ακόμη',
  slNotePh: 'σημείωση για τη σκηνοθεσία (προαιρετικά)',
  slName: 'Όνομα ομιλητή',
  slRole: 'Ιδιότητα',
  slQuotePh: 'Τι λέει (προαιρετικά, για υπότιτλους)',
  slReporterName: 'Ρεπόρτερ',
  slCamera: 'Κάμερα',
  slNumber: 'Αρ.',
  slAddLine: '+ γραμμή',
  slAddCg: 'Τίτλος CG',
  slRemoveCg: 'Αφαίρεση του CG',
  slNote: 'Σημείωση',
  slNoteBoxPh: 'Σημείωση παραγωγής, δεν διαβάζεται (π.χ. GREEN, ΓΕΦΥΡΑ - ΠΛΑΝΑ ΔΙΚΑΣΤΗΡΙΟ)',
  slNatsoundHint: 'Φυσικός ήχος από τις εικόνες, χωρίς αφήγηση.',
  slBoxes: 'κουτιά',
  slTotal: 'Σύνολο',
  // story view: exit and storyboard
  svExit: 'Έξοδος',
  svExitHint: 'Επιστροφή στον Οδηγό Δελτίου, στη γραμμή αυτής της είδησης',
  svNoCues: 'Δεν έχουν οριστεί video ή τίτλοι CG για αυτή την είδηση.',
  svKind: 'Είδος',
  svKindVideo: 'Video',
  svKindCg: 'Τίτλος CG',
  svAnchor: 'Θέση στο κείμενο',
  svContent: 'Περιεχόμενο',
  svDuration: 'Διάρκεια',
  svExpected: 'αναμενόμενη διάρκεια video',
  svNoBulletin: 'Εκτός δελτίου',
  svRecord: 'Στοιχεία',
  svWebHint: 'Η είδηση ως άρθρο για το alphanews.live, έτοιμο για δημοσίευση',
  // the portal's page (alphanews.live)
  waPreview: 'Άρθρο για το alphanews.live',
  waDraft: 'Προσχέδιο',
  waByAi: 'Γράφτηκε με AI',
  waPlain: 'Από το κείμενο της είδησης, χωρίς AI',
  waAiFailed: 'Η AI δεν απάντησε· το άρθρο είναι από το κείμενο της είδησης',
  waAgain: 'Ξανά με AI',
  waPublish: 'Δημοσίευση',
  waPublishStub: 'Η δημοσίευση στο alphanews.live δεν έχει συνδεθεί ακόμη: το άρθρο είναι έτοιμο, η σύνδεση με το CMS της ιστοσελίδας ανοίγει με ρύθμιση.',
  waWriting: 'Σύνταξη του άρθρου…',
  waBack: 'Πίσω στην είδηση',
  acMenu: 'Autocue',
  acFromPlayout: 'Από το playout',
  acLoadedAt: 'φορτώθηκε στο playout',
  acChosen: 'επιλογή με το χέρι',
  acUnload: 'Εκφόρτωση',
  acUnloadHint: 'Αδειάζει το autocue σε όλες τις οθόνες· φορτώνεται ξανά από το Control Room («Φόρτωση στο Control»)',
  acUnloadConfirm: 'Εκφόρτωση του autocue; Το κείμενο φεύγει από όλες τις οθόνες μέχρι να φορτωθεί ξανά δελτίο από το Control Room.',
  acUnloaded: 'Το autocue είναι άδειο. Περιμένει φόρτωση δελτίου από το Control Room («Φόρτωση στο Control»).',
  acUnloadedAt: 'εκφόρτωση',
  acNone: 'Δεν έχει φορτωθεί δελτίο στο playout. Φορτώστε το από το Control Room και τα ON του έρχονται εδώ, ή επιλέξτε δελτίο.',
  acFollow: 'Ακολουθεί τον αέρα',
  acWithVo: 'και V.O',
  acSmaller: 'Μικρότερα γράμματα',
  acLarger: 'Μεγαλύτερα γράμματα',
  acMirror: 'Καθρέφτης (για το γυαλί του autocue)',
  acExitFull: 'Έξοδος από την πλήρη οθόνη',
  acMeterNa: 'Ο browser δεν δίνει τώρα το επίπεδο του μικροφώνου',
  acMeterWords: 'Ο browser δεν δίνει την ένταση του μικροφώνου: η μπάρα δείχνει τις λέξεις που ακούγονται',
  acPrevStory: 'Προηγούμενο θέμα',
  acNextStory: 'Επόμενο θέμα',
  acFullscreen: 'Πλήρης οθόνη',
  acNoOn: 'χωρίς ON',
  acNext: 'ΕΠΟΜΕΝΟ',
  acEnd: 'ΤΕΛΟΣ ΔΕΛΤΙΟΥ',
  acHint: '↑ ↓ κύλιση · Space / PgDn επόμενη είδηση · PgUp προηγούμενη · Home αρχή · F πλήρης οθόνη · M καθρέφτης',
  acHintVoice: 'V φωνή (με τη φωνή, τα πλήκτρα μετακινούν το σημείο της)',
  acVoice: 'Φωνή',
  acVoiceTitle: 'Το autocue ακούει τον παρουσιαστή και ακολουθεί ό,τι διαβάζει (V)',
  acMic: 'Μικρόφωνο',
  acMicDefault: 'Μικρόφωνο συστήματος',
  acVoiceStarting: 'Ανοίγει το μικρόφωνο…',
  acVoiceLocal: 'Η ομιλία αναγνωρίζεται σε αυτόν τον υπολογιστή',
  acVoiceCloud: 'Η ομιλία αναγνωρίζεται από την υπηρεσία ομιλίας του browser',
  acVoiceCloudGoogle: 'Η ομιλία αναγνωρίζεται από την υπηρεσία του browser (της Google, στο Chrome)',
  acVoiceCloudMicrosoft: 'Η ομιλία αναγνωρίζεται από την υπηρεσία του browser (της Microsoft, στον Edge)',
  acVoiceCloudApple: 'Η ομιλία αναγνωρίζεται από την υπηρεσία του browser (της Apple)',
  acVoiceNetwork: 'Η υπηρεσία ομιλίας δεν απαντά· ξαναδοκιμάζει…',
  acVoiceEmpty: 'Η υπηρεσία ομιλίας ακούει αλλά δεν επιστρέφει λέξεις· το autocue δεν μπορεί να ακολουθήσει.',
  acVoiceEmptyEdge: 'Ο Edge ακούει, αλλά η υπηρεσία ομιλίας της Microsoft δεν επιστρέφει λέξεις· για τη φωνή ανοίξτε το autocue σε Chrome.',
  acVoiceUnsupported: 'Αυτός ο browser δεν αναγνωρίζει ομιλία. Ανοίξτε το autocue σε Chrome.',
  acVoiceDenied: 'Δεν δόθηκε άδεια για το μικρόφωνο ή για την υπηρεσία ομιλίας.',
  acVoiceNoLocal: 'Ο browser δεν έχει ελληνική αναγνώριση ομιλίας σε αυτόν τον υπολογιστή.',
  acVoiceDownloading: 'Ο browser κατεβάζει την ελληνική αναγνώριση ομιλίας. Δοκιμάστε ξανά σε λίγο.',
  acVoiceFailed: 'Η αναγνώριση ομιλίας σταμάτησε.',
  crPlanned: 'Προγραμματισμένο',
  crTotal: 'Σύνολο δελτίου',
  crRemaining: 'Υπόλοιπο',
  crEndsAt: 'Τέλος στις',
  crOver: 'πάνω',
  crUnder: 'κάτω',
  crOnAirFor: 'στον αέρα',
  crItemLeft: 'απομένει',
  crPlayNext: 'Επόμενο',
  crAutocueGo: 'Το autocue σε αυτό το θέμα',
  crAutocueHere: 'Εδώ είναι τώρα το autocue (πατήστε για να το φέρετε στην αρχή του θέματος)',
  crAutocueNone: 'Καμία οθόνη autocue δεν είναι ανοιχτή σε αυτό το δελτίο',
  crToEnd: 'Στο τέλος',
  crSkip: 'Παράλειψη',
  crUnskip: 'Επαναφορά',
  crSkipped: 'παράλειψη',
  crFollow: 'Ακολούθηση',
  crFullscreen: 'Πλήρης οθόνη',
  crTextSize: 'Μέγεθος γραμμάτων',
  crReadOnly: 'Μόνο προβολή: δεν έχετε δικαίωμα αλλαγής σειράς.',
  crKeys: '↑↓ επιλογή · Alt+↑↓ μετακίνηση · N επόμενο · E στο τέλος · S παράλειψη',
  crNoPlayout: 'χωρίς σύνδεση playout: η σειρά ισχύει για τον οδηγό και το autocue',
  // AI settings
  aiMenu: 'Βοηθός AI',
  aiAdminTitle: 'Βοηθός AI',
  aiAdminHint: 'Ποιος πάροχος και ποιο μοντέλο βοηθούν τους δημοσιογράφους, και το κλειδί API. Το κλειδί αποθηκεύεται κρυπτογραφημένο στον server και δεν εμφανίζεται ξανά.',
  aiAdminTip: 'Κάθε αίτημα καταγράφεται (χρήστης, εργασία, μοντέλο, tokens) χωρίς το κείμενο. Οι μεταβλητές περιβάλλοντος AI_PROVIDER / ANTHROPIC_API_KEY ισχύουν μόνο όσο δεν έχει αποθηκευτεί τίποτε εδώ.',
  aiCurrent: 'Τρέχουσα κατάσταση',
  aiSource: 'από',
  aiSourceSettings: 'ρυθμίσεις της εφαρμογής',
  aiSourceEnv: 'μεταβλητές περιβάλλοντος',
  aiProvider: 'Πάροχος',
  aiProviderOff: 'Απενεργοποιημένος',
  aiModel: 'Μοντέλο',
  aiEffort: 'Προσπάθεια',
  aiEffortLow: 'Χαμηλή (γρήγορη, φθηνή)',
  aiEffortMedium: 'Μεσαία (προεπιλογή)',
  aiEffortHigh: 'Υψηλή (πιο προσεκτική, ακριβότερη)',
  aiKey: 'Κλειδί API',
  aiKeyStored: 'αποθηκευμένο κλειδί',
  aiNoSecret: 'Ο server δεν έχει AIRPOST_SECRET, οπότε κλειδί δεν μπορεί να αποθηκευτεί εδώ. Ορίστε το στις μεταβλητές περιβάλλοντος και επανεκκινήστε.',
  aiKeyWhere: 'Το κλειδί ορίζεται στη σελίδα Κλειδιά API.',
  aiKeyMissing: 'δεν έχει οριστεί',
  keysMenu: 'Κλειδιά API',
  keysTitle: 'Κλειδιά API',
  keysHint: 'Τα κλειδιά των εξωτερικών υπηρεσιών (βοηθός AI, Associated Press) σε ένα σημείο. Φυλάσσονται κρυπτογραφημένα στον server και δεν εμφανίζονται ξανά.',
  keysTip: 'Κάθε αποθήκευση ή αφαίρεση καταγράφεται (χρήστης, κλειδί, τελευταίοι 4 χαρακτήρες). Το ίδιο το κλειδί δεν εμφανίζεται πουθενά — ούτε σε αρχεία καταγραφής. Οι μεταβλητές περιβάλλοντος του server ισχύουν μόνο για όσα κλειδιά δεν έχουν αποθηκευτεί εδώ.',
  keyStored: 'Αποθηκευμένο',
  keyFromEnv: 'Από το περιβάλλον του server',
  keyNotSet: 'Δεν έχει οριστεί',
  keyBy: 'από',
  keyEnvToo: 'υπάρχει τιμή και στις μεταβλητές του server· υπερισχύει η αποθηκευμένη εδώ',
  keyEnvOnly: 'Χρησιμοποιείται η τιμή από τις μεταβλητές περιβάλλοντος του server· αποθηκεύστε εδώ άλλη για να την αντικαταστήσετε',
  keyNew: 'νέο κλειδί',
  keyReplace: 'Αντικατάσταση με νέο κλειδί…',
  keyRemove: 'Αφαίρεση',
  keyRemoveConfirm: 'Να αφαιρεθεί το αποθηκευμένο κλειδί; Η υπηρεσία θα σταματήσει, εκτός αν υπάρχει τιμή στο περιβάλλον του server.',
  keyTest: 'Δοκιμή',
  keyTesting: 'Δοκιμή…',
  keySaved: 'το κλειδί αποθηκεύτηκε',
  keyRemoved: 'το κλειδί αφαιρέθηκε',
  keyTestApOk: 'Το AP δέχθηκε το κλειδί',
  keyTestApFeeds: 'ροές στο πλάνο του σταθμού',
  keyTestFailed: 'Η δοκιμή απέτυχε',
  keyAnthropicDesc: 'Το κλειδί του λογαριασμού Anthropic της εταιρείας, για τον βοηθό AI των συντακτών· δημιουργείται στο console.anthropic.com → API keys. Πάροχος, μοντέλο και προσπάθεια επιλέγονται στη σελίδα',
  keyElevenDesc: 'Το κλειδί ElevenLabs του σταθμού, για τη φωνή AI που διαβάζει τα σπικάζ των συντακτών (Κέντρο Video)· δημιουργείται στο elevenlabs.io → Profile → API keys',
  keyTestElevenOk: 'Το ElevenLabs δέχθηκε το κλειδί',
  keyTestElevenVoices: 'φωνές',
  keyApDesc: 'Το κλειδί AP Media API του πλάνου του σταθμού (από τον λογαριασμό AP ή το AP Customer Support). Με αυτό διαβάζονται οι ροές του Associated Press· μετά την αποθήκευση εμφανίζονται στις Προτεινόμενες της Νέας ροής, στη σελίδα',
  aiSettingsSaved: 'Οι ρυθμίσεις αποθηκεύτηκαν',
  aiEnabledWith: 'ο βοηθός είναι ενεργός με',
  aiStillOff: 'ο βοηθός παραμένει ανενεργός',
  aiTest: 'Δοκιμή',
  aiTesting: 'αποστολή δοκιμαστικού αιτήματος…',
  aiTestOk: 'Ο πάροχος απάντησε',
  aiTestFailed: 'Η δοκιμή απέτυχε',
  // HPress import
  importMenu: 'Εισαγωγή HPress',
  importTitle: 'Εισαγωγή από HPress',
  importHint: 'Οι παρτίδες που εξήχθησαν από το HPress (pnpm hpress extract, μόνο ανάγνωση) και φορτώθηκαν σε αυτή την εγκατάσταση: stage → transform → validate → import → reconcile.',
  importRuns: 'Εκτελέσεις σε αυτή τη διεργασία',
  importBatches: 'Παρτίδες στη βάση',
  importStarted: 'Έναρξη',
  importBatch: 'Παρτίδα',
  importBy: 'Από',
  importSource: 'Πηγή',
  importInserted: 'Εισήχθησαν',
  importUnchanged: 'Αμετάβλητα',
  importCounts: 'Μετρήσεις',
  importLog: 'Αναφορά',
  importNone: 'Καμία εκτέλεση από την τελευταία εκκίνηση',
  importTip: 'Η φόρτωση γίνεται με το εργαλείο της γραμμής εντολών από μηχάνημα του LAN που βλέπει το HPress (POST /api/admin/import/batches). Η ίδια παρτίδα ξαναφορτώνεται χωρίς διπλοεγγραφές.',
  // orthographer
  spell: 'Ορθογραφία',
  spellToggle: 'Ορθογραφικός έλεγχος στο κείμενο (κόκκινη υπογράμμιση· κλικ στη λέξη για προτάσεις)',
  spellNoSuggestions: 'Χωρίς πρόταση',
  spellAddWord: 'Προσθήκη στο λεξικό',
  spellIgnore: 'Αγνόηση',
  // AI help
  aiPanel: 'Βοηθός AI',
  aiDisabled: 'Η βοήθεια AI δεν είναι ενεργοποιημένη σε αυτή την εγκατάσταση (ρύθμιση AI_PROVIDER).',
  aiHint: 'Κάθε απάντηση είναι πρόταση: τίποτε δεν αλλάζει στην είδηση αν δεν πατήσετε Εφαρμογή. Ο βοηθός δεν προσθέτει γεγονότα· ελέγχετε πάντα ονόματα και αριθμούς.',
  aiProofread: 'Ορθογραφία & γραμματική',
  aiTitles: 'Προτάσεις τίτλου',
  aiShorten: 'Σύντμηση σε',
  aiSummary: 'Περίληψη για web',
  aiTranslate: 'Μετάφραση',
  aiTargetSeconds: 'Δευτερόλεπτα ανάγνωσης',
  aiApply: 'Εφαρμογή στο κείμενο',
  aiUseTitle: 'Χρήση',
  aiNoChanges: 'Δεν βρέθηκαν λάθη',
  aiNoText: 'Γράψτε πρώτα κείμενο',
  // users and roles (HPress: Διαχείριση → Χρήστες / Ομάδες)
  usersMenu: 'Χρήστες',
  rolesMenu: 'Ρόλοι',
  usersTitle: 'Χρήστες',
  usersHint: 'Λογαριασμοί του τμήματος: ποιος μπαίνει στο σύστημα και με ποιον ρόλο. Οι χρήστες δεν διαγράφονται· απενεργοποιούνται.',
  usersShowInactive: 'και ανενεργοί',
  usersTip: 'Χρήστης χωρίς κωδικό (μεταφορά από HPress) δεν μπορεί να συνδεθεί μέχρι να του ορίσετε κωδικό. Αλλαγή ρόλου ή απενεργοποίηση κλείνει αμέσως τις συνδέσεις του.',
  userNew: 'Νέος χρήστης',
  userEdit: 'Τροποποίηση χρήστη',
  displayName: 'Ονοματεπώνυμο',
  role: 'Ρόλος',
  status: 'Κατάσταση',
  active: 'Ενεργός',
  inactive: 'Ανενεργός',
  noPassword: 'χωρίς κωδικό',
  newPasswordOptional: 'Νέος κωδικός (προαιρετικά)',
  language: 'Γλώσσα',
  updated: 'Ενημέρωση',
  you: 'εσείς',
  rolesTitle: 'Ρόλοι και δικαιώματα',
  rolesHint: 'Κάθε ρόλος είναι ένα σύνολο δικαιωμάτων (τα γράμματα του HPress: R ανάγνωση, A νέα, M δικά του, C όλα, D διαγραφή, S σειρά, Q οδηγός, P autocue). Οι αλλαγές ισχύουν αμέσως για όλους τους χρήστες του ρόλου.',
  rolesTip: 'Οι ενσωματωμένοι ρόλοι τροποποιούνται αλλά δεν διαγράφονται. Ο ρόλος admin έχει πάντα όλα τα δικαιώματα.',
  roleNew: 'Νέος ρόλος',
  roleEdit: 'Τροποποίηση ρόλου',
  roleKey: 'Κλειδί',
  roleName: 'Όνομα',
  roleCopyFrom: 'Αντιγραφή δικαιωμάτων από',
  roleDeleteConfirm: 'Να διαγραφεί ο ρόλος',
  permissions: 'Δικαιώματα',
  users: 'Χρήστες',
  builtIn: 'ενσωματωμένος',
  allPermissions: 'όλα τα δικαιώματα',
  adminRoleFixed: 'Ο ρόλος admin έχει πάντα όλα τα δικαιώματα· μόνο το όνομά του αλλάζει.',
  noPlayersYet: 'Δεν έχει ληφθεί ακόμη λίστα players από το playout',
  ltoTagline: 'Αρχείο ταινιών LTO · προεπισκόπηση και ανάκτηση',
  ltoStatTapes: 'ταινίες',
  ltoStatItems: 'θέματα',
  ltoStatPreview: 'με προεπισκόπηση',
  ltoStatOnTape: 'σε ταινία',
  ltoStatRestoring: 'σε ανάκτηση',
  ltoAgent: 'Agent αρχείου',
  ltoAgentOnline: 'σε λειτουργία',
  ltoAgentOffline: 'εκτός σύνδεσης',
  ltoAgentNone: 'δεν έχει συνδεθεί',
  ltoAgentNoneHint: 'Ο agent τρέχει στον σταθμό, δίπλα στο LTO drive: γράφει στις ταινίες, στέλνει τα αντίγραφα προεπισκόπησης και κάνει τις ανακτήσεις.',
  ltoInDrive: 'στο drive',
  ltoViewSearch: 'Αναζήτηση',
  ltoViewTapes: 'Ταινίες',
  ltoViewRestores: 'Ανακτήσεις',
  ltoSearchPlaceholder: 'Τίτλος, περίληψη, σχόλια ή κωδικός ταινίας (π.χ. MS0050)…',
  ltoFilters: 'Φίλτρα',
  ltoOnlyPreview: 'Μόνο με προεπισκόπηση',
  ltoWithSummary: 'Με περίληψη',
  ltoClearTape: 'Όλες οι ταινίες',
  ltoCategoriesN: 'κατηγορίες',
  ltoResults: 'θέματα',
  ltoMore: 'Υπάρχουν κι άλλα: περιορίστε την αναζήτηση ή αυξήστε τις εγγραφές.',
  ltoRobotSearch: 'Αναζήτηση στη βιβλιοθήκη ταινιών',
  ltoRobotFetch: 'Ο βραχίονας φέρνει την ταινία',
  ltoPickItem: 'Επιλέξτε ένα θέμα για να το δείτε.',
  ltoPickTape: 'Επιλέξτε μια ταινία.',
  ltoCard: 'Καρτέλα',
  ltoTape: 'Ταινία',
  ltoFile: 'Αρχείο',
  ltoFormat: 'Μορφή',
  ltoOnTape: 'Στην ταινία',
  ltoProxyBadge: 'Προεπισκόπηση',
  ltoProxyHint: 'Μικρό αντίγραφο χαμηλής ποιότητας, μόνο για να δείτε το υλικό. Το αρχείο πλήρους ποιότητας είναι στην ταινία.',
  ltoNoProxy: 'Χωρίς προεπισκόπηση',
  ltoNoProxyHint: 'Το θέμα αρχειοθετήθηκε πριν κρατιούνται αντίγραφα προεπισκόπησης. Ζητήστε ανάκτηση για να το δείτε.',
  ltoPickLabel: 'Βίντεο',
  ltoPickDrop: 'Σύρετε εδώ το βίντεο',
  ltoPickOr: 'ή',
  ltoPickChoose: 'επιλέξτε αρχείο',
  ltoPickOther: 'Άλλο αρχείο',
  ltoPickRemove: 'Αφαίρεση βίντεο',
  ltoPickHint: 'Από αυτό γίνεται η προεπισκόπηση (640×360). Το ίδιο το αρχείο δεν κρατιέται: το πλήρες είναι στην ταινία.',
  ltoPickReplace: 'Το θέμα έχει ήδη προεπισκόπηση: ένα βίντεο εδώ την αντικαθιστά.',
  ltoPickLooking: 'Ανάγνωση του αρχείου…',
  ltoPickBrowser: 'Η προεπισκόπηση γίνεται εδώ, στον browser: στέλνεται μόνο αυτή, λίγα MB.',
  ltoPickServer: 'Μετά την Αποθήκευση το αρχείο ανεβαίνει στον server',
  ltoPickServerWhy: 'Ο browser δεν ανοίγει αυτό το είδος αρχείου, οπότε την προεπισκόπηση τη φτιάχνει ο server και μετά σβήνει το αρχείο. Αφήστε τη σελίδα ανοιχτή μέχρι να σταλεί.',
  ltoAbout: 'περίπου',
  ltoAtSpeed: 'στα',
  ltoAtLastSend: 'με την ταχύτητα της προηγούμενης αποστολής',
  ltoUnderMinute: 'λιγότερο από 1 λεπτό',
  ltoMinute: 'λεπτό',
  ltoHour: 'ώρα',
  ltoHours: 'ώρες',
  ltoPickNoServer: 'Ο browser δεν διαβάζει αυτό το αρχείο και ο server δεν έχει FFmpeg: την προεπισκόπηση θα τη φτιάξει ο agent του αρχείου.',
  ltoPickNoPicture: 'Το αρχείο δεν έχει εικόνα.',
  ltoPickTooBig: 'Το αρχείο είναι μεγαλύτερο απ’ όσο δέχεται ο server',
  ltoTrayTitle: 'Προεπισκοπήσεις',
  ltoJobMaking: 'Γίνεται η προεπισκόπηση',
  ltoJobSendingPreview: 'Αποστολή της προεπισκόπησης',
  ltoJobSending: 'Αποστολή του αρχείου στον server',
  ltoJobQueued: 'Σε αναμονή στον server',
  ltoJobProbing: 'Ο server διαβάζει το αρχείο',
  ltoJobServer: 'Ο server φτιάχνει την προεπισκόπηση',
  ltoJobStoring: 'Αποθήκευση',
  ltoJobDone: 'Η προεπισκόπηση είναι έτοιμη',
  ltoJobFailed: 'Η προεπισκόπηση δεν έγινε',
  ltoJobCancelled: 'Ακυρώθηκε',
  ltoJobOpen: 'Άνοιγμα',
  ltoJobLeft: 'ακόμα',
  ltoJobStay: 'Αφήστε τη σελίδα ανοιχτή μέχρι να τελειώσει',
  ltoJobCancelAsk: 'Να σταματήσει η προεπισκόπηση;',
  ltoAddPreview: 'Βίντεο για προεπισκόπηση',
  ltoAddPreviewHint: 'ή σύρετε ένα βίντεο εδώ',
  ltoPreviewFrom: 'Προεπισκόπηση',
  ltoSrcAgent: 'από τον agent',
  ltoSrcBrowser: 'στον browser',
  ltoSrcServer: 'στον server',
  ltoNoTapeHint: 'Το θέμα δεν έχει κωδικό ταινίας.',
  ltoRestoreTitle: 'Ανάκτηση από ταινία',
  ltoRestoreTo: 'Προορισμός',
  ltoWholeFile: 'Όλο το αρχείο',
  ltoPart: 'Τμήμα',
  ltoPartHint: 'Βάλτε IN και OUT στην προεπισκόπηση (πλήκτρα I και O) για να ζητήσετε μόνο ένα τμήμα.',
  ltoReason: 'Για ποιο λόγο (προαιρετικό), π.χ. «για το δελτίο των 20:00»',
  ltoRestoreAsk: 'Ζήτηση ανάκτησης',
  ltoRestoreAsked: 'Η ανάκτηση ζητήθηκε. Θα τη δείτε εδώ και στις Ανακτήσεις.',
  ltoRestoreExisting: 'Υπάρχει ήδη ίδια ανάκτηση σε εξέλιξη.',
  ltoManualHint: 'Το θέμα αρχειοθετήθηκε πριν από τον agent: την ανάκτηση την κάνει ο αρχειοθέτης με το χέρι.',
  ltoManualAgentOff: 'Ο agent δεν είναι συνδεδεμένος: την ανάκτηση την κάνει ο αρχειοθέτης με το χέρι.',
  ltoManualTarget: 'αρχειοθέτης',
  ltoItemRestores: 'Ανακτήσεις του θέματος',
  ltoStRequested: 'Σε αναμονή',
  ltoStLoading: 'Φόρτωση ταινίας',
  ltoStReading: 'Ανάγνωση',
  ltoStDone: 'Ολοκληρώθηκε',
  ltoStFailed: 'Απέτυχε',
  ltoStCancelled: 'Ακυρώθηκε',
  ltoMoveLoading: 'Φορτώθηκε',
  ltoMoveDone: 'Έγινε',
  ltoMoveDoneAsk: 'Πού βρίσκεται το αρχείο που ανακτήθηκε; (όνομα ή διαδρομή, προαιρετικό)',
  ltoMoveFailed: 'Απέτυχε',
  ltoMoveFailedAsk: 'Τι πήγε στραβά; (προαιρετικό)',
  ltoCancelAsk: 'Να ακυρωθεί η ανάκτηση;',
  ltoScopeOpen: 'Σε εξέλιξη',
  ltoScopeMine: 'Δικές μου',
  ltoScopeAll: 'Όλες',
  ltoRestoresCount: 'ανακτήσεις',
  ltoNowLoading: 'Φόρτωση ταινίας τώρα',
  ltoNowReading: 'Ανάγνωση από ταινία τώρα',
  ltoNoOpenRestores: 'Καμία ανάκτηση σε εξέλιξη.',
  ltoNoRestores: 'Καμία ανάκτηση.',
  ltoTapeSearch: 'Κωδικός ταινίας…',
  ltoLocation: 'Θέση',
  ltoAllLocations: 'Όλες οι θέσεις',
  ltoSortRecent: 'Πιο πρόσφατες',
  ltoSortBarcode: 'Κατά κωδικό',
  ltoTapesCount: 'ταινίες',
  ltoNoTapes: 'Καμία ταινία.',
  ltoItems: 'θέματα',
  ltoSizeUnknown: 'χωρητικότητα άγνωστη',
  ltoLocLibrary: 'Βιβλιοθήκη',
  ltoLocDrive: 'Στο drive',
  ltoLocShelf: 'Ράφι',
  ltoLocOffsite: 'Εκτός σταθμού',
  ltoLocUnknown: 'Θέση άγνωστη',
  ltoStateActive: 'Σε χρήση',
  ltoStateFull: 'Γεμάτη',
  ltoStateRetired: 'Εκτός χρήσης',
  ltoGeneration: 'Γενιά',
  ltoGenUnknown: 'Γενιά άγνωστη',
  ltoSlot: 'Θέση / ράφι',
  ltoSlotHint: 'π.χ. Ράφι Β-12 ή slot 34',
  ltoState: 'Κατάσταση',
  ltoNotes: 'Σημειώσεις',
  ltoTapeSaved: 'Αποθηκεύτηκε',
  ltoLastWritten: 'Τελευταία εγγραφή',
  ltoOnThisTape: 'Θέματα στην ταινία',
} as const;

/** The active locale ('el' or 'en'), for Intl formatting. */
export function currentLocale(): 'el' | 'en' {
  return current === en ? 'en' : 'el';
}

export type Key = keyof typeof el;

export const en: Record<Key, string> = {
  ...el,
  appSubtitle: 'Newsroom Computer System',
  station: 'ALPHA TV Cyprus',
  home: 'Home',
  print: 'Print',
  help: 'Help',
  user: 'User',
  currentPassword: 'Current password',
  newPassword: 'New password',
  repeatPassword: 'Repeat new password',
  passwordRule: 'The new password needs at least 10 characters',
  passwordMismatch: 'The two passwords do not match',
  passwordChanged: 'Password changed; it applies from the next sign-in',
  tabNews: 'News',
  tabTopics: 'Assignments',
  tabVideo: 'Video Archive',
  tabHub: 'Video Hub',
  tabAdmin: 'Administration',
  newStory: 'New Story',
  dayStories: "Today's Stories",
  rundownGuide: 'Rundown',
  quickFind: 'Quick Search',
  archive: 'News Archive',
  loginTitle: 'Sign in - AirPost',
  loginHint: "Enter 'User' and 'Password' and press 'Sign in'",
  username: 'User',
  password: 'Password',
  login: 'Sign in',
  rundownTitle: 'Rundown',
  rundownSelectHint: "Select 'Bulletin' and 'Date' and press 'Search'",
  bulletinDetails: 'Bulletin',
  bulletin: 'Bulletin',
  bulletinDate: 'Bulletin date',
  choose: '< Select bulletin >',
  search: 'Search',
  clear: 'Clear',
  tipRequired: 'Bulletin and bulletin date are required',
  todaysRundowns: "Today's rundowns",
  gridTitle: 'RUNDOWN',
  gridHint: "Use the 'Edit in rundown' icon to change the story number and title, then press 'Save'.",
  colSel: 'S',
  colActions: 'Actions',
  rowMore: 'More',
  colNum: 'No.',
  colTitle: 'Title',
  colCat: 'Cat.',
  colRead: 'Read',
  colVideo: 'Video',
  colTotal: 'Total',
  colRt: 'RT',
  colOrder: 'Ord.',
  colType: 'Type',
  colGraphics: 'Graphics',
  newsCount: 'Stories',
  bulletinTime: 'Bulletin time',
  revision: 'Rev.',
  cut: 'Cut',
  printBulletin: 'Print bulletin',
  printList: 'Print list',
  showSelected: 'Show selected',
  copyBulletin: 'Copy bulletin',
  refresh: 'Refresh',
  publish: 'Publish',
  selectAll: 'Select all',
  selectNone: 'Select none',
  tipCopy: 'Copying a bulletin needs no selection: ALL stories of the bulletin are copied.',
  tipDash: "To blank the story number in the rundown use '-'.",
  tipKeys: 'Keys: ↑↓ move cursor, Enter open, F2 edit in rundown, Alt+↑↓ reorder, Space select, Insert separator, Delete cut or remove a separator, F5 refresh.',
  editInGuide: 'Edit in rundown',
  editRecord: 'Edit story',
  viewRecord: 'View story',
  save: 'Save',
  cancel: 'Cancel',
  back: 'Back',
  separator: 'Separator',
  separatorAddHint: 'A separator below the selected row (Insert)',
  separatorAddAfter: 'A separator right below this row',
  separatorLabel: 'Separator label (F2 or double-click; empty for a plain band of colour)',
  separatorRemove: 'Remove the separator (Delete)',
  float: 'Float',
  unfloat: 'Unfloat',
  duplicateLinked: 'Duplicate (shared text)',
  duplicateCopy: 'Copy (independent)',
  removed: 'Removed',
  restore: 'Restore',
  confirmCut: 'Cut the selected stories from the bulletin?',
  nothingSelected: 'No stories selected.',
  conflict: 'Another user changed the rundown. The rundown was refreshed; repeat the action.',
  live: 'live',
  offline: 'offline',
  reconnecting: 'reconnecting…',
  present: 'Present',
  copyTo: 'Copy bulletin',
  copy: 'Copy',
  copyConfirm: 'Copy all stories into the selected bulletin?',
  copyDone: 'Copy finished',
  selectedActions: 'Actions on selected stories',
  printSelected: 'Print selected',
  backToGuide: 'Back to rundown',
  device: 'Autocue device',
  profile: 'Encoding',
  profileLegacy: 'win-1253 (as HPress)',
  profileUtf8: 'UTF-8 (separate profile)',
  preview: 'Preview',
  send: 'Send',
  unsupportedChars: 'Characters not representable in win-1253',
  noUnsupported: 'All characters are representable.',
  fileWritten: 'File written',
  download: 'Download',
  line: 'line',
  column: 'column',
  storyEdit: 'Edit Story',
  storyNew: 'New Story',
  storyView: 'View Story',
  storyViewHint: 'Story details',
  author: 'Author',
  department: 'Department',
  origin: 'Origin',
  category: 'Category',
  title: 'Title',
  storyNumber: 'Story no.',
  guideComments: 'Rundown comments',
  text: 'Text',
  createdAt: 'Created',
  createdBy: 'Created by',
  updatedAt: 'Last modified',
  updatedBy: 'Modified by',
  readTime: 'Read time',
  readOverride: 'Read time (manual)',
  videoTime: 'Video time',
  order: 'Transmission order',
  itemType: 'Type',
  insertTemp: 'Insert local draft',
  saveTemp: 'Save local draft',
  revert: 'Revert',
  history: 'History',
  tipRequiredFields: 'Fields marked * are required',
  stateLocal: 'Local draft',
  stateSaved: 'Saved to AirPost',
  savedPopup: 'Saved',
  statePublished: 'Published',
  stateAcked: 'Acknowledged',
  statePending: 'Saving…',
  stateError: 'Save failed',
  stateConflict: 'Conflict: the story was changed by',
  keepMine: 'Keep mine',
  keepTheirs: 'Take theirs',
  leasedBy: 'Being edited by',
  readOnlyNow: 'Read only',
  words: 'words',
  computed: 'computed',
  dayTitle: "Today's Stories",
  dayHint: "Press the icon in column 'E' to edit a story, or the title link to see its details.",
  go: 'Go',
  colEdit: 'E',
  colCreatedBy: 'Created by',
  colBulletin: 'Bulletin',
  colUpdated: 'Last modified',
  totalTime: 'Total story time',
  tipDayDates: "Shows today's and yesterday's bulletin dates. Default sort is last modified, descending; click a header to sort.",
  previous: 'Previous',
  next: 'Next',
  of: 'of',
  quickTitle: 'Quick search in department',
  archiveTitle: 'Advanced search in the news archive',
  searchHint: "Fill in the fields and press 'Search'",
  fromDate: 'from',
  toDate: 'to',
  datePlaceholder: 'DD/MM/YYYY',
  pickDate: 'Calendar',
  badDate: 'Not a valid date (DD/MM/YYYY)',
  createdFrom: 'Created by',
  updatedFrom: 'Last modified by',
  comments: 'Comments',
  records: 'Records',
  sorting: 'Sort by',
  direction: 'Direction',
  asc: 'Ascending',
  desc: 'Descending',
  byOrder: 'Transmission order',
  byUpdated: 'Last modified',
  results: 'Results',
  noResults: 'No stories found',
  tipOperators: 'Text fields: words separated by comma or space (all), % and _ wildcards, & | ~ or AND OR NOT.',
  welcome: 'Welcome to the Newsroom Computer System',
  homeGoodMorning: 'Good morning',
  homeGoodAfternoon: 'Good afternoon',
  homeGoodEvening: 'Good evening',
  homeKpiBulletins: 'bulletins today',
  homeKpiRows: 'items in them',
  homeKpiFeedsHour: 'feed items in the last hour',
  homeNoRundowns: 'No bulletin has been opened for today yet. Open one from the Rundown Guide.',
  homeRowsUnit: 'items',
  homeLatestStories: 'Latest stories',
  homeNoStories: 'No stories today yet.',
  homeAllFeeds: 'All feeds',
  homeNoFeeds: 'No feeds yet. The administrator adds sources under Administration → Feeds.',
  homeFeedsLocal: 'Cyprus',
  homeFeedsWorld: 'World',
  homeChooseFeeds: 'Choose feeds',
  homeChooseFeedsHint: 'Which feeds your own start screen shows. With none selected, all of them are shown.',
  homeUpdated: 'Updated',
  draft: 'Draft',
  statusDraft: 'DRAFT',
  statusDraftShort: 'DRAFT',
  statusReady: 'FINAL',
  statusReadyShort: 'FINAL',
  statusApproved: 'APPROVED',
  statusApprovedShort: 'APPR.',
  finalise: 'Finalise',
  finaliseHint: "The story stops being a draft; changes keep saving automatically, but a journalist's change makes it a draft again",
  backToDraft: 'Back to draft',
  backToDraftHint: 'The story becomes a draft again',
  approve: 'Approve',
  approveHint: "The editor-in-chief's approval; only with right C",
  unapprove: 'Withdraw approval',
  demotedNote: 'The change made the story a draft again; finalise it once more when you are done.',
  draftAutosaveNote: 'saved automatically as you write',

  linked: 'Linked',
  published: 'Published',
  pending: 'Pending',
  synced: 'Synced',
  blocked: 'Blocked',
  failed: 'Failed',
  unlinked: 'Unlinked',
  loading: 'Loading…',
  error: 'Error',
  today: 'Today',
  topicsMenuSearch: 'Search assignments',
  topicsMenuNew: 'New assignment',
  topicsSearchTitle: 'Search the assignments diary',
  topicsHint: 'The default page shows 100 records sorted by date and time, ascending',
  topicDetails: 'Assignment details',
  topicNew: 'New assignment',
  topicEdit: 'Edit assignment',
  topic: 'Topic',
  topicDate: 'Date',
  topicTime: 'Time',
  reporter: 'Reporter',
  appointment: 'Appointment',
  remarks: 'Remarks',
  originPerson: 'Origin (person)',
  originFree: 'Origin (text)',
  topicsNone: 'No assignments found',
  topicsMore: 'There are more records; narrow the search or raise Records',
  topicsCount: 'assignments',
  tomorrow: 'Tomorrow',
  thisWeek: 'Week',
  delete: 'Delete',
  confirmDeleteTopic: 'Delete this assignment? It stays in the history.',
  topicConflict: 'Another user changed this assignment. The current version is shown; apply your changes again.',
  topicSaved: 'Assignment saved',
  anyCategory: '< Select category >',
  nobody: '< Nobody >',
  freeText: 'Text',
  action: 'Action',
  by: 'By',
  when: 'When',
  videoHubMenu: 'Video Hub',
  hubTitle: 'Video Hub',
  hubHint: 'Every clip the playout holds: pick one and open it in the editor; cut, straps, voice-over and music on the timeline.',
  mamTitle: 'Video Hub',
  mamHint: 'Every clip the playout holds: facets, search, each clip\'s facts and the way into the editor',
  mamSearch: 'Search title, file or ID',
  mamSort: 'Sort',
  mamSortNewest: 'Newest',
  mamSortTitle: 'Title',
  mamSortLength: 'Length',
  mamSortFile: 'File',
  mamGrid: 'Grid',
  mamList: 'List',
  mamResults: 'clips',
  mamFacetStatus: 'Status',
  mamFacetUse: 'Use',
  mamFacetLength: 'Length',
  mamFacetDate: 'Date',
  mamUsed: 'In use',
  mamUnused: 'Unused',
  mamNew: 'New (24 h)',
  mamLenShort: 'up to 15″',
  mamLenMid: '15″ – 1′',
  mamLenLong: 'over 1′',
  mamToday: 'Today',
  mamWeek: '7 days',
  mamOlder: 'Older',
  mamClear: 'Clear filters',
  mamNone: 'No clip matches these filters',
  mamPick: 'Pick a clip from the list',
  mamAsset: 'File facts',
  mamId: 'ID',
  mamFile: 'File',
  mamDuration: 'Length',
  mamStatus: 'Status',
  mamSize: 'Size',
  mamUpdated: 'Updated on the playout',
  mamFirstSeen: 'First seen',
  mamLastSeen: 'Last seen',
  mamLibrary: 'Playout library',
  mamUses: 'Used in stories',
  mamNoUses: 'Not used in a story',
  mamCopyId: 'Copy ID',
  mamCopied: 'Copied',
  mamProxy: 'Download proxy',
  mamKeys: 'Arrows: select · Enter or double-click: edit',
  mamViaStoryboard: 'storyboard',
  mamViaStory: 'the story\'s video',
  mamViaRow: 'bulletin row',
  mamPending: 'Waiting for a file',
  mamPlayerEmpty: 'Pick an asset to preview',
  mamVu: 'Audio level (dBFS), left and right',
  mamSelection: 'Selection',
  mamClearIn: 'Clear IN',
  mamMarkIn: 'Mark IN',
  mamClearOut: 'Clear OUT',
  mamMarkOut: 'Mark OUT',
  mamToStart: 'To the start',
  mamToIn: 'To IN',
  mamBack5: 'Back 5 frames',
  mamBack1: 'Back 1 frame',
  mamFwd1: 'Forward 1 frame',
  mamFwd5: 'Forward 5 frames',
  mamToOut: 'To OUT',
  mamToEnd: 'To the end',
  mamPlayRange: 'Play from IN to OUT (Enter)',
  mamLoop: 'Loop between IN and OUT',
  mamMute: 'Mute',
  mamColType: 'Type',
  mamColStatus: 'State',
  mamColPreview: 'Preview',
  mamColName: 'Name',
  mamColDescription: 'Description',
  mamColDuration: 'Duration',
  mamColKind: 'Asset type',
  mamColInserted: 'Inserted',
  mamColOrigin: 'Location',
  mamColSize: 'Size',
  mamColTags: 'Keywords',
  mamColOnline: 'Online',
  mamColUsed: 'In use',
  mamColEdits: 'Edits',
  mamColSubclips: 'Subclips',
  mamSecAll: 'All assets',
  mamSecClip: 'Playout clips',
  mamSecUpload: 'Story imports',
  mamSecMusic: 'Music',
  mamSecVoiceover: 'Voice-overs',
  mamSecUsed: 'Clips in use',
  mamSecUnused: 'Unused clips',
  mamSecNew: 'New (24 hours)',
  mamKindClip: 'Playout clip',
  mamKindUpload: 'Import',
  mamKindMusic: 'Music',
  mamKindVoiceover: 'Voice-over',
  mamViaOwner: 'belongs to the story',
  mamAddedToBasket: 'added to the basket',
  mamItemUpdated: 'The basket item\'s IN/OUT changed',
  mamYou: 'you',
  mamMetaSaved: 'Metadata saved',
  mamSubclipName: 'Subclip name (optional)',
  mamNavLibrary: 'Library',
  mamNavState: 'State',
  mamNavWork: 'Work',
  mamBasket: 'Basket',
  mamKeysHelp: '↑↓ select · X tick · Ctrl+A all · B to the basket · E edit · Space, J K L play · I O marks · ← → frames · Enter IN→OUT',
  mamAssets: 'Assets',
  mamSearchAll: 'Search: title, file, description, keyword, story or ID',
  mamColumns: 'Columns',
  mamColumnsReset: 'Default columns',
  mamAddToBasket: 'Add to the basket',
  mamDownload: 'Download',
  mamClearSelection: 'Clear the selection (Esc)',
  mamSelected: 'selected',
  mamNoneSearch: 'No asset matches the search',
  mamNoneHere: 'No assets here',
  mamCheckPage: 'Select the whole page',
  mamRows: 'Rows',
  mamOf: 'of',
  mamFirstPage: 'First page',
  mamPrevPage: 'Previous page',
  mamNextPage: 'Next page',
  mamLastPage: 'Last page',
  mamUpdateItem: 'Update basket item',
  mamUpdateItemHint: 'The player\'s IN/OUT onto the basket item',
  mamAddRangeHint: 'The asset with its IN/OUT into the basket',
  mamSaveSubclipHint: 'Save IN/OUT as a subclip of the asset',
  mamSubclip: 'Subclip',
  mamEdit: 'Edit',
  mamEditHint: 'Opens the video in the editor: its edit in one of your stories, or a new edit when IN–OUT marks are set; if none of your stories plays it, a story is made for it',
  mamEditRangeHint: 'A new edit from the player’s IN to its OUT (without marks: the whole video, or the edit it already has)',
  mamEditOpening: 'Opening the editor…',
  mamDetails: 'Details',
  mamPickAsset: 'Pick an asset from the list',
  mamStationMusic: 'station music',
  mamBasketTotal: 'Total duration',
  mamMoveUp: 'Up',
  mamMoveDown: 'Down',
  mamRemoveTicked: 'Remove the ticked',
  mamClearBasketConfirm: 'Again to empty',
  mamClearBasket: 'Empty the basket',
  mamToEdit: 'To an edit',
  mamToEditHint: 'The basket becomes a new edit: its video in order as pieces with their IN/OUT, the music on A2, the story\'s voice-overs on A1',
  mamBasketEmpty: 'Drag assets here or press B',
  mamGone: 'no longer exists',
  mamEditMade: 'The edit is made.',
  mamDroppedHint: 'Left out:',
  mamDroppedOther: 'belongs to another story',
  mamDroppedLength: 'unknown length and no OUT',
  mamOpenEdit: 'Open the edit',
  mamToStory: 'Into an existing story',
  mamFindStory: 'Find the story by its title',
  mamOwnsItems: 'owns imports or voice-overs in the basket',
  mamToNewStory: 'Into a new story',
  mamNewStoryTitle: 'Title of the new story',
  mamMakeEdit: 'Make the edit',
  mamOpenStory: 'The story',
  mamDescPlaceholder: 'What it shows, who speaks, where and when it was shot',
  mamTagsPlaceholder: 'Keywords, separated by commas',
  mamSubclips: 'Subclips',
  mamNoSubclips: 'Set IN and OUT in the player and press ✂ Subclip',
  mamEdits: 'Edits',
  mamNoEdits: 'No edits',
  mamHistory: 'History',

  hubAll: 'All',
  hubNew: 'New',
  hubUnused: 'Unused',
  hubUsed: 'In use',
  hubSearch: 'Search title or file',
  hubRefresh: 'Refresh',
  hubPending: 'Waiting for a file:',
  hubNoClips: 'No clips found',
  hubNewBadge: 'NEW',
  hubUsedOnce: '1 story',
  hubUsedMany: 'stories',
  hubPickOne: 'Pick a clip from the list',
  hubStory: 'Story',
  hubStoryNone: '— none —',
  hubStorySearch: 'Search a story to assign to',
  hubAssign: 'Assign to the story',
  hubAssigned: 'The clip is in the story',
  hubNoStoryHint: 'No story plays it. Edit makes one with this clip; or pick, find or make one here.',
  hubNewStory: 'New story from the clip',
  hubNewStoryHint: 'Creates a story titled after the clip, with the clip in its ΒΙΝΤΕΟ ΜΕ ΗΧΟ box',
  hubNewStoryDone: 'The story was created with the clip in it; open the editor on the timeline',
  hubTrim: 'Trim (in / out)',
  hubHere: 'From where the clip is playing',
  hubTrimSaved: 'Trim saved',
  hubRows: 'bulletin rows updated',
  hubStraps: 'Straps inside the clip',
  hubNoStrapsYet: 'No strap yet: type a name and role, or take a proposal from the AI.',
  hubLine1: 'Line 1 (name or title)',
  hubLine2: 'Line 2 (role), optional',
  hubAddStrap: 'Add strap',
  hubAi: 'AI proposals',
  hubAiRun: "From the story's text",
  hubAiHint: "The AI reads the story's text and proposes people with their role and short titles; nothing goes in without your click",
  hubAiNothing: 'The AI found no people or titles in the text',
  hubAiAddAtNow: 'Strap at the point the clip is playing',
  hubAiAdd: 'here',
  hubReady: 'Ready for air?',
  hubCheckClip: 'Clip on the playout',
  hubCheckStory: 'Story',
  hubCheckNoStory: 'Not in a story yet',
  hubCheckTrim: 'Trim',
  hubCheckFull: 'Plays in full',
  hubCheckStraps: 'straps',
  hubCheckNoStraps: 'No straps',
  hubVoiceover: 'Voice-over',
  voNone: 'No voice-over yet',
  voScriptPh: "The words you will read (filled from the story's ΣΠΗΚΑΖ)",
  voRecord: 'Record',
  voRecordHint: "Records from the computer's microphone; the text stays in front of you",
  voStop: 'Stop',
  voSave: 'Save',
  voDiscard: 'Discard',
  voSaved: 'The voice-over is saved with the story',
  voMicDenied: 'The microphone was not allowed',
  voAi: 'AI voice',
  voRecorded: 'Recording',
  voAiRead: 'Let the AI voice read it',
  voAiHint: 'The AI voice (ElevenLabs) reads the text; the file stays with the story',
  voAiDone: 'The AI voice read the text',
  voAiOff: 'AI voice: add the ElevenLabs key under API keys to have the text read',
  voAirNote: 'The voice-over stays with the story for the director and the sound desk; the playout does not mix it over the pictures yet (render pending).',
  veTitle: 'Edit',
  veBack: 'Back to the story',
  veToStory: 'To the story',
  veToStoryHint: "the edit's changes go into the story, exported so that its preview shows them",
  veToStoryBusy: 'going into the story',
  veToStoryAnyway: 'press "To the story" again to go back without it',
  veSaving: 'Saving…',
  veSaved: 'Saved',
  veUnsaved: 'Unsaved changes',
  veConflict: 'Changed elsewhere; open it again',
  veSaveChanges: 'Save changes',
  veLeave: 'Leave without saving',
  veLeaveHint: 'Back to the story without the changes of this visit; the edit, the story and its video stay as they were at the last save',
  veLeaveNothing: 'Back to the story; there are no changes to save',
  veLeaveBusy: 'The save has already started; wait for it to finish',
  veLeaveConfirm: 'The changes to the edit are not saved and will be lost. Leave without saving?',
  veDraftFound: 'Unsaved changes to this edit were found in this browser',
  veDraftRestore: 'Restore',
  veDraftDiscard: 'Discard',
  veExportFastHint: 'Writes the edit as an MP4 in the browser (WebCodecs), faster than real time, and saves it with the story',
  veExportSlowHint: 'This browser has no WebCodecs: writes the edit as a WebM in real time and saves it with the story; keep the tab in front',
  veNoRecorder: 'This browser cannot write video',
  veExporting: 'Saving',
  veExportKeep: 'Keep the tab open until it finishes',
  veExported: 'The file was written and saved with the story',
  veExportFellBack: 'the fast export failed, it was recorded in real time',
  veDownload: 'Download',
  veApply: 'Into the storyline',
  veApplyHint: "Puts the cut and the straps into the story's storyline; the player plays the edit",
  veApplied: "The edit is in the story's storyline",
  veToIn: 'To the start of the cut (Home)',
  veToOut: 'To the end of the cut (End)',
  vePlay: 'Play (space)',
  vePause: 'Pause (space)',
  veFrameBack: 'One frame back (←, with shift 1″)',
  veFrameFwd: 'One frame forward (→, with shift 1″)',
  veSetIn: 'IN',
  veSetInHint: 'The piece starts here: what is before goes (I)',
  veSetOut: 'OUT',
  veSetOutHint: 'The piece ends here: what is after goes (O)',
  veAddStrap: 'Strap',
  veAddStrapHint: 'A new strap where it is playing (or double-click the T1 track)',
  veSnap: 'Snap',
  veSnapHint: "Snap to the other items' edges while dragging (S)",
  veZoomIn: 'Zoom in (+)',
  veZoomOut: 'Zoom out (−)',
  veFit: 'Fit',
  veFitHint: 'The whole clip in the width of the timeline',
  veLength: 'Length',
  veAnalysing: 'Analysing the clip…',
  veTrackVideo: 'Video',
  veTrackStraps: 'Straps',
  veTrackVo: 'Voice-over',
  veTrackMusic: 'Music',
  veHint: 'Drag clips, sounds, transitions and lower thirds from the bins onto the tracks; a piece\'s ends to trim it, the whole piece to move it; C cuts the selected track, Shift+C every track; M/S mute and solo each track. Keys: space, ←/→ (shift: 1″), Home/End, C, D (dip), T (transition), I, O, S, +/−, Delete, Ctrl+Z / Ctrl+Shift+Z.',
  veCut: 'Cut',
  veStraps: 'Straps',
  veVo: 'Voice-over',
  veMusic: 'Music',
  veSound: 'Sound',
  veCutHint: 'The part that goes to air; the playout gets the same in/out.',
  veNoStraps: 'No strap; press ＋, double-click the T1 track, or take a proposal from the AI.',
  veStrapEmpty: '(no text)',
  veStrapAt: 'In',
  veStrapDur: 'Length',
  veStrapHere: 'Where it is playing',
  veNoVo: 'No voice-over',
  veLevel: 'Level',
  veNoMusic: 'No music',
  veUploadMusic: 'Upload',
  veDuck: 'Ducks under the voice-over',
  veMusicNote: 'Only music the station has the rights to use.',
  veSourceLevel: "The clip's own sound",
  veSoundHint: 'Each track\'s level, mute (M) and solo (S); the meter by the timecode shows the level of the mix.',
  veStatus: 'Status',
  veStatusCut: 'Cut',
  veStatusRendered: 'Video saved',
  veStatusNotRendered: 'Video not saved',
  veBinLibrary: 'Library',
  veBinUploads: 'Imports',
  veBinLt: 'Lower thirds',
  veBinSearch: 'Search clips',
  veBinEmpty: 'No clips',
  veBinAdd: 'To the end of the timeline',
  veBinDrag: 'Drag a clip onto the V1 track, or press ＋ to add it at the end.',
  veImport: 'Import video',
  veImportHint: 'MP4, WebM or MOV up to 200 MB; goes to the end of the timeline',
  veImporting: 'Importing…',
  veImported: 'The file is on the timeline',
  veImportTooBig: 'The file is over 200 MB',
  veNoUploads: 'No imports yet; press "Import video".',
  veRemoveUpload: 'Delete the import',
  veSplit: 'Cut',
  veSplitHint: 'Cuts the selected track where it is playing (C); Shift+C cuts every track',
  veRemovePiece: 'Remove',
  veRemovePieceHint: 'Takes the piece off the timeline (Delete)',
  vePiece: 'Piece',
  vePieceSource: 'From',
  vePieceIn: 'IN in the clip',
  vePieceOut: 'OUT in the clip',
  vePieceHint: 'Drag the ends of the piece to trim it, the whole piece to change the order; C cuts it where it is playing.',
  veMoveEarlier: 'Earlier',
  veMoveLater: 'Later',
  veLt1: 'Name',
  veLt2: 'Name + role',
  veLtAdd: 'Where it is playing',
  veLtHint: 'Drag a lower third onto the T1 track, or press ＋; the text is typed on the right.',
  veLtDesign: 'Design',
  veLtDesignHint: "The station's lower-third design in this edit: on the monitor, in the file and on the playout",
  veLtDesignBulletin: "The bulletin's",
  veLtSample1: 'NAME SURNAME',
  veLtSample2: 'ROLE',
  veAppliedSequence: "The edit is linked to the story's clip; the player plays the export. The playout will play it once the file is ingested (pending).",
  veNeedsWebCodecs: 'An edit of several pieces is written only in a browser with WebCodecs (Chrome, Edge)',
  vePieces: 'pieces',
  veAirNoteSequence: 'With several pieces the air copy is the exported file; its ingest into the playout is pending.',
  veDip: 'Music dip',
  veDips: 'Dips',
  veDipAdd: 'Dip here',
  veDipAddHint: 'Lowers the music for 4″ from where it is playing (D); drag its ends for the range',
  veDipNeedsMusic: 'Put music on the A2 track first',
  veDipLevel: 'Level',
  veDipFrom: 'From',
  veDipTo: 'To',
  veDipHint: 'Inside the range the music drops to this share of its level, while the journalist speaks in the picture, say; where two dips overlap the lower one counts.',
  veNoDips: 'No dip; press ＋ or D where it is playing, or drag one over the music.',
  veAddAtPlayhead: 'Where it is playing',
  veAir: 'For air',
  veAirHint: 'Render on the playout from the full-quality files (masters)',
  veAirTitle: 'Render for air',
  veAirIntro: "The playout makes the edit from the full-quality files (MXF), next to its masters; only the edit, its graphics and the story's files leave from here. When it is done the clip joins the playout's library and the story plays it.",
  veAirStart: 'Start render',
  veAirAgain: 'Render again',
  veAirCancel: 'Stop',
  veAirClose: 'Close',
  veAirGraphics: 'Drawing the graphics',
  veAirSending: 'Sending to the playout',
  veAirPending: 'Sending files',
  veAirQueued: 'Waiting on the playout',
  veAirRunning: 'Rendering',
  veAirDone: 'Ready on the playout',
  veAirIngesting: 'the playout is checking the file…',
  veAirLinked: 'the story plays this clip',
  veAirNotLinked: 'the clip is in the library; the story has no video for it to replace',
  veAirFailed: 'Failed',
  veAirCancelled: 'Cancelled',
  veAirStale: 'The edit changed after this render; the story plays the original clip again.',
  veAirNoPlayout: 'No playout is configured.',
  veAirBlocked: "The playout does not reproduce yet (the browser's export stays the copy):",
  veAirPiece: 'Piece',
  veAirBlock_aspect: 'a shape other than 16:9',
  'veAirBlock_video-hidden': 'V1 hidden',
  veAirBlock_look: 'colour / filter',
  veAirBlock_motion: 'a move (zoom / pan)',
  veAirBlock_effect: 'an effect',
  veAirBlock_keyframes: 'frame keyframes',
  veAiEdit: 'AI edit',
  veAiEditHint: 'The AI looks at frames of the clips and the story\'s text and builds the edit; Ctrl+Z takes it back',
  veAiIntro: 'The AI looks at a few frames of each clip you choose, reads the story and the voice-over, and builds pieces, transitions, straps and music. The edit lands on the timeline and Ctrl+Z takes it back.',
  veAiInstruction: 'Instruction (optional)',
  veAiInstructionPh: 'e.g. fast pace, open on the satellite shot, a strap for the mayor',
  veAiTarget: 'Length',
  veAiTargetAuto: 'auto',
  veAiUseVo: 'With the voice-over',
  veAiUseMusic: 'With music',
  veAiClips: 'Clips',
  veAiSearch: 'Search the library for more clips',
  veAiInEdit: 'in the edit',
  veAiPickOne: 'Pick at least one clip',
  veAiFrames: 'Frames of the clips',
  veAiThinking: 'The AI is editing…',
  veAiGo: 'Build the edit',
  veAiUndoNote: 'Ctrl+Z takes the AI\'s edit back',
  veAiDone: 'The AI built the edit (Ctrl+Z to undo).',
  // the editor v5: keyframes, templates, handles, the fitted layout
  veAnWipe: 'Wipe',
  veCopyStyle: 'Copy style',
  veDecoBar: 'Bar at the left',
  veDecoFrame: 'Frame',
  veDecoNone: 'None',
  veDecoTag: 'Label on the first line',
  veDecoUnderline: 'Line under it',
  veDuplicate: 'Duplicate',
  veFullscreen: 'Full screen',
  veGrid: 'Thirds grid',
  veHandleSize: 'Drag to resize',
  veHandleTurn: 'Drag to turn (Shift: 15° steps)',
  veHideTrack: 'Hide the track (not in the export either)',
  veInspector: 'Properties',
  veKeyAdd: 'Keyframe here',
  veKeyAll: 'Keyframe everything here',
  veKeyAllHint: 'Keyframe the place, size, turn and opacity where it is playing, or take them away (K)',
  veKeyNext: 'To the next keyframe',
  veKeyPrev: 'To the previous keyframe',
  veKeyRemove: 'Remove the keyframe',
  veKeyframes: 'keyframes',
  veLockTrack: 'Lock the track',
  veMagnetHint: 'The main track keeps no gaps: what goes out closes up',
  veMainSequence: 'Main sequence',
  veMonZoom: 'Monitor size',
  vePasteStyle: 'Paste style',
  vePlaceSize: 'Place and size',
  vePlainTexts: 'Plain texts',
  veSafeArea: 'Title-safe area',
  veShape: 'Shape',
  veShowTrack: 'Show the track',
  veSplitterHint: 'Drag to make the timeline taller or shorter',
  veStyleCopied: 'Style copied; Ctrl+V on another of its kind',
  veTemplates: 'Templates',
  veTime: 'Time',
  veTools: 'Tools',
  veTplBreaking: 'Breaking news',
  veTplBreakingSample: 'BREAKING\nWrite the story\'s headline',
  veTplFigure: 'Figure',
  veTplFigureSample: '00%\nwhat the figure counts',
  veTplHeadline: 'Social headline',
  veTplHeadlineSample: 'Your headline here',
  veTplLive: 'Live',
  veTplLiveSample: '● LIVE',
  veTplLocation: 'Location',
  veTplLocationSample: 'LOCATION',
  veTplName: 'Name and role',
  veTplNameSample: 'Full name\nRole',
  veTplQuote: 'Quote card',
  veTplQuoteSample: '“The quote here”\nWho says it',
  veTplSection: 'Section title',
  veTplSectionSample: 'SECTION',
  veTxAccent: 'Decoration colour',
  veTxDeco: 'Decoration',
  veTxDesign: 'Design',
  veTxLinesHint: 'The first line is the title; the next (Enter) get smaller with "Second lines".',
  veTxSecond: 'Second lines',
  veUnlockTrack: 'Unlock the track',
  // the editor v4: texts, photos, looks, frame, speed, effects, format
  veAddOverlay: 'Over the picture (V2), where it is playing',
  veAddPhotoPiece: 'As a piece on V1, where it is playing',
  veAddText: 'Text',
  veAnFade: 'Fade',
  veAnIn: 'In',
  veAnLength: 'Animation length',
  veAnNone: 'None',
  veAnOut: 'Out',
  veAnPop: 'Pop',
  veAnSlideDown: 'Slide down',
  veAnSlideLeft: 'Slide in from the right',
  veAnSlideRight: 'Slide out to the right',
  veAnSlideUp: 'Slide up',
  veAnType: 'Typewriter',
  veAnimation: 'Animation',
  veAspectPortrait: 'Portrait · Instagram',
  veAspectSquare: 'Square · feed',
  veAspectTall: 'Vertical · Reels, TikTok, Stories',
  veAspectWide: 'Landscape · TV, YouTube',
  veAutoCaptions: 'Captions from the voice-over',
  veAutoCaptionsHint: 'From the script of each voice-over on A1, spread over its length by the length of its phrases (not speech recognition); the ones made before are replaced.',
  veBackground: 'Background',
  veBgBlack: 'Black',
  veBgBlur: 'Blurred from the picture',
  veBgColor: 'Colour',
  veBinEffects: 'Effects',
  veBinFilters: 'Filters',
  veBinFormat: 'Format',
  veBinImages: 'Photos',
  veBinText: 'Text',
  veCaption: 'Caption',
  veCaptionStyleAll: 'Same style for all',
  veCaptionStyleAllHint: 'Every caption takes this one\'s font, colours, place and animation',
  veCaptions: 'Captions',
  veCaptionsMade: 'captions from the voice-over (Ctrl+Z to undo)',
  veClearCaptions: 'Remove captions',
  veDragOnMonitor: 'You can also drag it on the monitor to move it.',
  veEffectAddHint: 'On the selected piece (or the one playing); or drag it onto a piece',
  veEffectsHint: 'Press an effect for the selected piece, or drag it onto a piece on V1 or onto the monitor. Its strength is in the inspector (Effects).',
  veFiltersHint: 'Press a filter for the selected piece (or the one playing), or drag it onto a piece. Strength and colour adjustments are in the inspector (Colour).',
  veFitContain: 'Whole picture',
  veFitCover: 'Fill the frame (crops)',
  veFlBw: 'B&W',
  veFlCinematic: 'Cinematic',
  veFlCool: 'Cool',
  veFlDramatic: 'Dramatic',
  veFlFade: 'Faded',
  veFlNoir: 'Noir',
  veFlNone: 'None',
  veFlVintage: 'Vintage',
  veFlVivid: 'Vivid',
  veFlWarm: 'Warm',
  veFontCondensed: 'Condensed',
  veFontDisplay: 'Display',
  veFontMono: 'Mono',
  veFontSans: 'Sans',
  veFontSerif: 'Serif',
  veFormatNote: 'The playout plays 16:9 only; the other shapes are for social media.',
  veFps: 'Frame rate',
  veFrBottom: 'Bottom',
  veFrCrop: 'Crop',
  veFrFlipH: 'Mirror',
  veFrFlipV: 'Upside down',
  veFrLeft: 'Left',
  veFrOpacity: 'Opacity',
  veFrRight: 'Right',
  veFrRotation: 'Rotation',
  veFrScale: 'Size',
  veFrTop: 'Top',
  veFrX: 'Across',
  veFrY: 'Down',
  veFreeze: 'Freeze frame',
  veFreezeFrame: 'Frozen frame',
  veFreezeHint: 'The frame where it is playing holds for 2″ between the two halves of its piece (F)',
  veFreezeNone: 'A still is already playing here',
  veFxBars: 'Letterbox bars',
  veFxFlash: 'Flash',
  veFxGlitch: 'Glitch',
  veFxGrain: 'Grain',
  veFxHint: 'The flash fires at the start of the piece; the others last as long as the piece.',
  veFxShake: 'Shake',
  veImageImported: 'The photo is in; drag it onto V1 or V2.',
  veImageTooBig: 'The photo is over 15 MB',
  veImagesHint: 'Drag a photo onto V1 for a piece, or onto V2 (or the monitor) to lay it over the picture: a logo, a map, a portrait.',
  veImportPhoto: 'Upload a photo',
  veLkAdjust: 'Adjust',
  veLkAmount: 'Strength',
  veLkBlur: 'Blur',
  veLkBrightness: 'Brightness',
  veLkContrast: 'Contrast',
  veLkSaturation: 'Saturation',
  veLkTemperature: 'Temperature',
  veLkVignette: 'Vignette',
  veMoAmount: 'Amount',
  veMoNone: 'None',
  veMoPanDown: 'Pan down',
  veMoPanLeft: 'Pan left',
  veMoPanRight: 'Pan right',
  veMoPanUp: 'Pan up',
  veMoZoomIn: 'Zoom in',
  veMoZoomOut: 'Zoom out',
  veMotion: 'Camera move (Ken Burns)',
  veNoCanvasFilters: 'This browser does not apply filters on a canvas: here and in its export only the tints and the vignette show. Edit in Chrome or Edge.',
  veNoCaptions: 'No voice-over with a script on A1',
  veNoImages: 'No photos yet',
  veNoOverlays: 'Nothing over the picture yet',
  veNoTexts: 'No texts yet',
  veOutput: 'Export',
  veOvWidth: 'Width',
  veOverlaysCount: 'pictures over',
  veReset: 'Reset',
  veResolution: 'Resolution',
  veSpeed: 'Speed',
  veSpeedFrozen: 'A frozen frame has no speed; change its length under Basic or by dragging its end.',
  veSpeedHint: 'the piece\'s sound follows (its pitch too)',
  veSpeedLength: 'Length:',
  veSpeedPhoto: 'A photo has no speed; change its length under Basic or by dragging its end.',
  veSpotsHint: 'Quick place in the frame',
  veTabBasic: 'Basic',
  veTabColor: 'Colour',
  veTabEffects: 'Effects',
  veTabFrame: 'Frame',
  veTabSpeed: 'Speed',
  veText: 'Text',
  veTextAddHint: 'Where it is playing (T2); or drag it onto T2 or the monitor',
  veTextBinHint: 'Press a style for a text where it is playing, or drag it onto T2. Type the words in the inspector and drag the text on the monitor.',
  veTextsCount: 'texts',
  veTrackOverlay: 'Pictures',
  veTrackText: 'Texts',
  veTxBold: 'Bold',
  veTxBox: 'Box',
  veTxBoxOpacity: 'Box opacity',
  veTxBreaking: 'Breaking',
  veTxBreakingSample: 'BREAKING',
  veTxCaption: 'Caption',
  veTxCaptionSample: 'Caption',
  veTxCenter: 'Centre',
  veTxColor: 'Colour',
  veTxCredit: 'Credit',
  veTxCreditSample: 'Source',
  veTxFont: 'Font',
  veTxItalic: 'Italic',
  veTxLeft: 'Left',
  veTxLocation: 'Location',
  veTxLocationSample: 'LOCATION',
  veTxOutline: 'Outline',
  veTxPlace: 'Place',
  veTxPlaceholder: 'Type the text (Enter for a new line)',
  veTxQuote: 'Quote',
  veTxQuoteSample: '“The quote”',
  veTxRight: 'Right',
  veTxShadow: 'Shadow',
  veTxSize: 'Size',
  veTxSocial: 'Social',
  veTxSocialSample: 'Watch what happened',
  veTxSubtitle: 'Subheading',
  veTxSubtitleSample: 'Subheading',
  veTxTitle: 'Title',
  veTxTitleSample: 'TITLE',
  veTxUpper: 'Capitals',
  veTxWidth: 'Width',
  veWaiting: 'Loading the picture…',
  veAudioBinHint: 'Drag a voice-over onto A1 or music onto A2, or press ＋ for where it is playing.',
  veAudioIn: 'From',
  veAudioOut: 'To',
  veBeds: 'Music',
  veBinAudio: 'Sound',
  veBinTransitions: 'Transitions',
  veCutHere: 'Cut here',
  veDuckLevel: 'How far it drops',
  veEndFade: 'End fade',
  veEndFadeHint: 'The end fades to black',
  veEndFadeNone: 'No end fade',
  veEndFadeBlack: 'To black',
  veEndFadeWhite: 'To white',
  veFadeFromBlack: 'From black',
  veFadeFromWhite: 'From white',
  veFadeIn: 'Fade in',
  veFadeOut: 'Fade out',
  veMeter: 'Sound level (left / right)',
  veMixer: 'Mixer',
  veMusicClipHint: 'The music drops by itself under the voice-over (A2) and in the dips; C cuts it where it is playing.',
  veVoClipHint: 'Drag the ends to trim, the whole clip to move it; C cuts it where it is playing; the music drops under it.',
  veMute: 'Mute the track',
  veSolo: 'Only this track',
  veNewTake: 'New voice-over',
  veNoBeds: 'No music; upload a file.',
  veNormalise: 'Normalise',
  veNormaliseHint: 'Brings the clip\'s loudest peak to −1 dB',
  veNormaliseWait: 'The sound is still loading; try again in a moment',
  veNothingToCut: 'Nothing plays on this track at this point',
  vePieceSound: 'Piece sound',
  veTrackSound: 'Clip sound',
  veSoundDetach: 'Separate audio',
  veSoundDetachHint: 'Separate the audio from the picture: the piece\'s sound goes to track A3, to move, cut or delete on its own',
  veSoundRelink: 'Re-link audio',
  veSoundRelinkHint: 'The sound goes back into its piece (its clips on A3 are removed)',
  veSoundOnA3: 'on A3, apart from the picture',
  veSoundDetached: 'The audio is now on A3: move, cut or delete it apart from the picture',
  veSoundRelinked: 'The audio is back in its piece',
  veSoundPickPiece: 'Select a piece on V1 to separate its audio',
  veSoundNone: 'This piece has no sound (a photo or a still)',
  veSoundSpeed: 'Audio separates only at normal speed (1×)',
  veSoundClipHint: 'A piece\'s sound apart from its picture: drag the ends to trim, the whole clip to move it; C cuts it, Delete removes it; "Re-link audio" (L) puts it back in the piece.',
  veSoundTrackHint: 'The sound of the pieces you separate from their pictures goes here: select a piece on V1 and press ✂♪ or L.',
  veSoundNoClips: 'No audio separated from its picture yet.',
  veUndo: 'Undo (Ctrl+Z)',
  veRedo: 'Redo (Ctrl+Shift+Z)',
  veSplitAll: 'All tracks',
  veSplitAllHint: 'Cuts every track where it is playing (Shift+C)',
  veTakes: 'The story\'s voice-overs',
  veTrAddHint: 'On the cut nearest to where it is playing (T)',
  veTrCut: 'Cut (no transition)',
  veTrDefault: '0.6″ · drag it onto a cut',
  veTrDissolve: 'Dissolve',
  veTrDipBlack: 'Through black',
  veTrDipWhite: 'Through white',
  veTrWipe: 'Wipe',
  veTrPush: 'Push',
  veTrFirst: 'Start',
  veTrFromPrev: 'Transition from the previous piece',
  veTrHint: 'Drag a transition onto a cut on the V1 track, or press ＋ for the cut nearest to where it is playing.',
  veTrNoneFirst: 'No fade at the start',
  veTransitions: 'transitions',
  veAirNote: 'On air the playout plays the clip with the cut and the straps as CG; voice-over and music are heard only in the exported file (ingest into the playout pending).',
  slEdit: 'Edit',
  slEditOpen: 'Open the edit',
  slEditHint: 'Cut, straps, voice-over and music on a timeline',
  slEditRendered: 'edit · rendered ✓',
  slEditDraft: 'edit',
  hubOpenEditor: 'Edit on the timeline',
  hubOpenEditorHint: 'Cut, straps, voice-over and music on a timeline, on a page of its own',
  hubMusic: 'Music',
  hubMusicStub: 'Music: no licensed library yet (pending)',
  hubRender: 'Render',
  hubRenderStub: 'Render: the clip plays as it is from the playout; mixing/export is not set up (pending)',
  videosMenuSearch: 'Search videos',
  videosMenuNew: 'New video',
  videosSearchTitle: 'Search the video archive',
  videosHint: 'Duration is computed from TC out and TC in. Click the type or the title to open the item.',
  videoDetails: 'Video item details',
  videoNew: 'New video item',
  videoEdit: 'Edit video item',
  videoType: 'Type',
  anyType: '< Select type >',
  tapeNo: 'Tape no.',
  itemNo: 'Item no.',
  eventDate: 'Event date',
  tcIn: 'TC in',
  tcOut: 'TC out',
  videoDuration: 'Duration',
  videoSummary: 'Summary',
  videoCategories: 'Categories',
  videosNone: 'No video items found',
  videosCount: 'video items',
  viewStandard: 'Standard view',
  viewShort: 'With short summary',
  viewFull: 'With full summary',
  confirmDeleteVideo: 'Delete this video item? It stays in the history.',
  videoConflict: 'Another user changed this item. The current version is shown; apply your changes again.',
  videoSaved: 'Video item saved',
  tcFormat: 'HH:MM:SS',
  colMedia: 'Video (playout)',
  mediaDialogTitle: 'Link a playout clip',
  mediaSearch: 'Search the playout library',
  mediaNone: 'No clips found',
  mediaCurrent: 'Current clip',
  mediaAssign: 'Link',
  mediaClear: 'Remove clip',
  mediaHint: 'Only rows with a linked clip are sent to the player. Reorders and removals propagate automatically, never to the on-air event.',
  playoutPlayer: 'Player',
  playoutOnAir: 'on air',
  storyVideo: 'VIDEO',
  storyVideoNone: 'No video set',
  storyVideoChoose: 'Choose clip',
  storyVideoVirtual: 'Virtual video',
  storyVideoVirtualHint: 'Reserves a code until the clip is ready. Name the file with the code (e.g. V-261026-017_neoklis.mxf); once it reaches the playout library it replaces the code on every bulletin by itself.',
  storyVideoRemove: 'Remove',
  storyVideoSaveFirst: 'Save the story first to set a video',
  storyVideoRows: 'rundown rows updated',
  storyVideoCode: 'Code',
  storyboard: 'Storyboard',
  storyboardHint: 'The cues of the story in playing order: video (a clip or a virtual code) and CG titles. Type ΒΙΝΤΕΟ ΜΕ ΗΧΟ, ΤΙΤΛΟΣ 1, ΦΑΣΑ or ΡΕΠΟΡΤΑΖ in the script and set the cue under it.',
  storyboardEmpty: 'No cues yet. Type ΒΙΝΤΕΟ ΜΕ ΗΧΟ or ΤΙΤΛΟΣ 1 in the script and set the cue under it, or add one here.',
  storyboardSaved: 'saved',
  cueAddVideo: 'Video',
  cueAddCg: 'CG title',
  cuePreview: 'Preview',
  cuePreviewEdit: 'the edit, as in the editor',
  cuePreviewCut: 'the cut of the edit; its titles come from the CG',
  cuePreviewNoExport: 'the edit has no export yet; the original clip plays',
  cueEdit: 'Edit',
  cueTemplate: 'Title type',
  cueDurationS: 'Time on air (seconds)',
  cueLine: 'Line',
  cueNoPreview: 'The playout has no preview for this clip',
  cueOrphan: 'The heading of this cue is no longer in the script',
  cueManual: 'no place in the script; plays after the others',
  cueTotal: 'total video duration',
  cuePlaylistHint: 'The playlist of every bulletin is available to the automation: GET /api/rundowns/:id/playlist',
  storyVideoExpected: 'expected duration',
  virtualWaiting: 'Virtual video; waiting for the file carrying this code',
  virtualBadge: 'virtual',
  virtualReplaced: 'The virtual video was replaced by the file',
  copyCode: 'Copy code',
  mediaPanel: 'Media',
  mediaPanelNoRow: 'Select a row of the rundown',
  mediaPanelNoStory: 'This row has no story; clips are linked to stories only',
  mediaToPlayout: 'PLAYOUT',
  mediaOnRow: 'on the row',
  graphicsAdd: 'Add / edit graphics',
  graphicsNotReported: 'not reported',
  storyText: 'Script',
  close: 'Close',
  edit: 'Edit',
  noPermission: 'You do not have permission for this page',
  tabFeeds: 'Feeds',
  feedsMenu: 'News feeds',
  feedsTitle: 'Incoming feeds',
  feedsHint: 'What the sources the department follows (RSS / Atom) are carrying. Click an item for its summary and "New story" with title, text and source prefilled.',
  feedsAll: 'All',
  feedsOther: 'Other',
  feedsNoSources: 'No feeds defined yet; an administrator adds them in Administration → News feeds.',
  feedsEmpty: 'No items for this selection',
  feedsNewStory: 'New story from this',
  feedsOpenSource: 'Open source',
  feedRead: 'Read',
  feedReading: 'Reading the full text…',
  feedNoFullText: 'Neither the feed nor the page gave the full text; open the source.',
  feedsAp: 'Associated Press',
  feedsApNotConfigured: "is not connected. AP publishes no public RSS; it needs the station's AP Media API key (AP_MEDIA_API_KEY on the server).",
  feedsApFeeds: "feeds available on the station's plan; they are listed under Suggested in New feed.",
  feedsApError: 'did not answer',
  feedsMore: 'Older',
  feedsSourceLine: 'Source',
  justNow: 'now',
  feedsAdminTitle: 'News feeds',
  feedsAdminHint: 'The RSS / Atom sources the system reads, how often, and whether the last read worked. Items are kept for a month.',
  feedsAdminTip: 'Suggested sources: those that answered with a valid feed when checked on 26/10/2026. Every address can be checked with Preview before it is saved.',
  feedsNew: 'New feed',
  feedsEdit: 'Edit feed',
  feedsName: 'Name',
  feedsGroup: 'Group',
  feedsInterval: 'Every',
  feedsLastRead: 'Last read',
  feedsItems: 'Items',
  feedsError: 'error',
  feedsFetchNow: 'Read now',
  feedsPause: 'Pause',
  feedsResume: 'Resume',
  feedsDeleteConfirm: 'Delete the feed and its items?',
  feedsSuggested: 'Suggested',
  feedsPreview: 'Preview',
  feedsNewItems: 'new items',
  feedsInFeed: 'in the feed',
  minutes: 'minutes',
  feedsAgent: 'Request identity',
  feedsAgentBrowser: 'as a browser (for sources that reject feed readers, e.g. PIO)',
  feedsAgentHint: 'Normally the system identifies itself as the AirPost feed reader. Some firewalls (gov.cy) accept browsers only.',
  controlTitle: 'PLAYOUT CONTROL',
  controlShort: 'Playout',
  controlHint: 'Drag rows into their running order; every reorder or clip change reaches the player at once. The on-air row and the next one are protected.',
  relay: 'relay',
  publishManage: 'Playout / Publish',
  publishLink: 'Link to playout',
  onAir: 'On air',
  nextUp: 'Next',
  dragToReorder: 'Drag to reorder (or Alt+↑/↓)',
  noClip: 'no clip',
  menu: 'Menu',
  holdToReorder: 'Hold a row and drag it to reorder',
  moveUp: 'Up',
  moveDown: 'Down',
  linkedHere: 'linked',
  crTitle: 'Control Room',
  crPickHint: 'The control-room board for one bulletin: large type for the gallery screen, on air / next, timings, and reordering with one button or by dragging.',
  crNoBulletins: 'No bulletin has been opened for today.',
  crOtherDay: 'Another day',
  crPrevDay: 'Previous day',
  crNextDay: 'Next day',
  crYesterday: 'Yesterday',
  crOtherIsToday: "Today's bulletins are above. Pick another date for an earlier or a coming bulletin.",
  crNoBulletinsOn: 'No bulletin on',
  crLoad: 'Load to Control',
  crNotLoaded: 'The rundown is not loaded to the playout',
  crAutocueEmpty: 'The autocue is empty (unloaded)',
  crLoadHint: "The bulletin's videos go into the player's list in rundown order; anything else the player holds goes, except what is on air.",
  crLoadTitle: 'Load the bulletin to the playout',
  crLoadNote: "The bulletin's videos are loaded into the player in rundown order and anything else in the player's list is removed. A clip that is playing is not touched; a clip sitting paused or stopped is stopped and removed too. From then on every reorder or video change in the rundown follows by itself.",
  crLoadPlayer: 'Player',
  crLoadGo: 'Load',
  crLoadSent: "Sent to the playout; the player's list updates in a few seconds.",
  crNoPlayers: 'No player found on the playout. Is the relay connected? (Administration → Playout / MOS)',
  slStoryline: 'Storyline',
  slText: 'Text',
  slTextHint: 'The script as free text',
  slHint: 'The story as a playlist: every box is a step (ON, video, title, statement, credits…). The autocue text, the timings and the exports come from the boxes. Drag a box by its header to reorder, and the menu into the list to add.',
  slEmpty: 'An empty story. Add the first box from the menu on the left, or drag it here.',
  slAdd: 'Add',
  slAfterBox: 'Goes after box',
  slAtEnd: 'Goes at the end',
  slInsertAfter: 'Insert below',
  slDragMenu: 'Or drag it where you want it',
  slDragBox: 'Drag by the header to move it',
  slDropHere: 'Drop it here',
  cueDragManual: 'Drag to reorder the manual cues',
  slRead: 'Presenter',
  slVo: 'Voice-over',
  slSoundVideoHint: "Video with its own sound; on the playout it plays from the bulletin's player",
  slVoVideoHint: 'Pictures without sound; the presenter speaks over them. On the playout it plays from the VO player',
  voPlayerTag: 'VO player',
  crLoadVoPlayer: 'VO player',
  crLoadVoHint: "The player the bulletin's VO videos (pictures without sound) are loaded to; videos with sound go to the Player",
  crLoadVoNone: 'None: VO clips on the same player',
  crLoadVoUsual: 'usual',
  crLoadVoSame: 'The VO clips will play on the same player as the videos with sound.',
  slpTitle: 'On air',
  slpPreview: 'PREVIEW',
  slpOnAir: 'ON AIR',
  slpStudio: 'STUDIO',
  slpNoClip: 'No clip yet',
  slpNoPreview: 'The playout has no preview for this clip',
  slpEmpty: 'Add boxes to see the story as it will go on air',
  slpPlay: 'Play (space)',
  slpPause: 'Pause (space)',
  slpStop: 'From the start (Home)',
  slpPrev: 'Previous box (←)',
  slpNext: 'Next box (→)',
  slpHint: 'Videos play from the playout, texts at reading speed (3.3 words/s), titles and cards for their CG duration; a title inside a video comes in at its second; a VO inside an ON plays in a window beside the presenter.',
  slpPip: 'A VO inside the ON: it plays in a window while the presenter talks',
  slAt: 'at',
  slAtHint: 'The second of the box before it at which this box comes in',
  slAttach: 'Into the video',
  slAttachPrev: 'Over the previous box',
  slAttachHint: 'The box goes inside the box before it, at the second you set, taking no time of its own (a video takes the picture for its length)',
  slDetach: 'After',
  slDetachHint: 'The box becomes a step of its own again, after the box before it',
  slInside: 'Inside',
  slInsideAdd: 'inside',
  slInsideAddHint: 'Add a box inside this one (title, video, card, ON…), at the next free second; you can also drag a box onto it',
  slDropInto: 'Drop the title into the box to show it over its pictures',
  slModeOnHint: 'The presenter reads it in the studio (autocue)',
  slModeVoHint: 'Read over the pictures (voice-over)',
  slReadPh: 'What the presenter reads…',
  slVoPh: 'The voice-over over the pictures…',
  slNoClip: 'No clip yet',
  slNotePh: 'a note for the director (optional)',
  slName: 'Speaker',
  slRole: 'Role',
  slQuotePh: 'What they say (optional, for subtitles)',
  slReporterName: 'Reporter',
  slCamera: 'Camera',
  slNumber: 'No.',
  slAddLine: '+ line',
  slAddCg: 'CG title',
  slRemoveCg: 'Remove the CG',
  slNote: 'Note',
  slNoteBoxPh: 'A production note, not read (e.g. GREEN, BRIDGE - COURT SHOTS)',
  slNatsoundHint: 'Natural sound from the pictures, no narration.',
  slBoxes: 'boxes',
  slTotal: 'Total',
  svExit: 'Exit',
  svExitHint: 'Back to the rundown, on the row of this story',
  svNoCues: 'No video or CG titles are set for this story.',
  svKind: 'Kind',
  svKindVideo: 'Video',
  svKindCg: 'CG title',
  svAnchor: 'Place in the script',
  svContent: 'Content',
  svDuration: 'Duration',
  svExpected: 'expected video duration',
  svNoBulletin: 'Not in a bulletin',
  svRecord: 'Record',
  svWebHint: 'The story as an article for alphanews.live, ready to publish',
  waPreview: 'Article for alphanews.live',
  waDraft: 'Draft',
  waByAi: 'Written with AI',
  waPlain: "From the story's text, without AI",
  waAiFailed: "The AI did not answer; the article is from the story's text",
  waAgain: 'Again with AI',
  waPublish: 'Publish',
  waPublishStub: "Publishing to alphanews.live is not connected yet: the article is ready; the link to the site's CMS is switched on by configuration.",
  waWriting: 'Writing the article…',
  waBack: 'Back to the story',
  acMenu: 'Autocue',
  acFromPlayout: 'From the playout',
  acLoadedAt: 'loaded on the playout',
  acChosen: 'chosen by hand',
  acUnload: 'Unload',
  acUnloadHint: 'Empties the autocue on every screen; the Control Room loads it again ("Load to Control")',
  acUnloadConfirm: 'Unload the autocue? The text leaves every screen until a bulletin is loaded again from the Control Room.',
  acUnloaded: 'The autocue is empty. It waits for a bulletin to be loaded from the Control Room ("Load to Control").',
  acUnloadedAt: 'unloaded',
  acNone: 'No bulletin is loaded on the playout. Load one from the Control Room and its ONs come here, or choose a bulletin.',
  acFollow: 'Follows the air',
  acWithVo: 'and V.O',
  acSmaller: 'Smaller text',
  acLarger: 'Larger text',
  acMirror: 'Mirror (for the prompter glass)',
  acExitFull: 'Leave full screen',
  acMeterNa: 'The browser is not giving the microphone level now',
  acMeterWords: 'The browser gives no microphone level: the bar shows the words being heard',
  acPrevStory: 'Previous story',
  acNextStory: 'Next story',
  acFullscreen: 'Full screen',
  acNoOn: 'no ON',
  acNext: 'NEXT',
  acEnd: 'END OF BULLETIN',
  acHint: '↑ ↓ scroll · Space / PgDn next story · PgUp previous · Home top · F full screen · M mirror',
  acHintVoice: 'V voice (with the voice on, the keys move its place)',
  acVoice: 'Voice',
  acVoiceTitle: 'The autocue listens to the presenter and follows what they read (V)',
  acMic: 'Microphone',
  acMicDefault: 'System microphone',
  acVoiceStarting: 'Opening the microphone…',
  acVoiceLocal: 'Speech is recognised on this computer',
  acVoiceCloud: 'Speech is recognised by the browser’s speech service',
  acVoiceCloudGoogle: 'Speech is recognised by the browser’s service (Google’s, in Chrome)',
  acVoiceCloudMicrosoft: 'Speech is recognised by the browser’s service (Microsoft’s, in Edge)',
  acVoiceCloudApple: 'Speech is recognised by the browser’s service (Apple’s)',
  acVoiceNetwork: 'The speech service is not answering; trying again…',
  acVoiceEmpty: 'The speech service hears but returns no words; the autocue cannot follow.',
  acVoiceEmptyEdge: 'Edge hears, but Microsoft’s speech service returns no words; for voice, open the autocue in Chrome.',
  acVoiceUnsupported: 'This browser cannot recognise speech. Open the autocue in Chrome.',
  acVoiceDenied: 'No permission for the microphone or the speech service.',
  acVoiceNoLocal: 'The browser has no Greek speech recognition on this computer.',
  acVoiceDownloading: 'The browser is downloading Greek speech recognition. Try again shortly.',
  acVoiceFailed: 'Speech recognition stopped.',
  crPlanned: 'Planned',
  crTotal: 'Bulletin total',
  crRemaining: 'Remaining',
  crEndsAt: 'Ends at',
  crOver: 'over',
  crUnder: 'under',
  crOnAirFor: 'on air for',
  crItemLeft: 'left',
  crPlayNext: 'Play next',
  crAutocueGo: 'The autocue to this story',
  crAutocueHere: 'The autocue is here now (press to bring it to the start of the story)',
  crAutocueNone: 'No autocue screen is open on this bulletin',
  crToEnd: 'To the end',
  crSkip: 'Skip',
  crUnskip: 'Put back',
  crSkipped: 'skipped',
  crFollow: 'Follow',
  crFullscreen: 'Full screen',
  crTextSize: 'Text size',
  crReadOnly: 'View only: you may not reorder.',
  crKeys: '↑↓ select · Alt+↑↓ move · N play next · E to the end · S skip',
  crNoPlayout: 'no playout link: the order applies to the rundown and the autocue',
  aiMenu: 'AI assistant',
  aiAdminTitle: 'AI assistant',
  aiAdminHint: 'Which provider and model help the journalists, and the API key. The key is stored encrypted on the server and never shown again.',
  aiAdminTip: 'Every request is logged (user, task, model, tokens) without the text. The environment variables AI_PROVIDER / ANTHROPIC_API_KEY apply only while nothing is saved here.',
  aiCurrent: 'Current state',
  aiSource: 'from',
  aiSourceSettings: 'the app settings',
  aiSourceEnv: 'environment variables',
  aiProvider: 'Provider',
  aiProviderOff: 'Disabled',
  aiModel: 'Model',
  aiEffort: 'Effort',
  aiEffortLow: 'Low (fast, cheap)',
  aiEffortMedium: 'Medium (default)',
  aiEffortHigh: 'High (more careful, dearer)',
  aiKey: 'API key',
  aiKeyStored: 'stored key',
  aiNoSecret: 'The server has no AIRPOST_SECRET, so a key cannot be stored here. Set it in the environment and restart.',
  aiKeyWhere: 'The key is set on the API keys page.',
  aiKeyMissing: 'not set',
  keysMenu: 'API keys',
  keysTitle: 'API keys',
  keysHint: 'The keys of the outside services (AI assistant, Associated Press) in one place. They are kept encrypted on the server and are never shown again.',
  keysTip: 'Every save or removal is logged (user, key, last 4 characters). The key itself appears nowhere, not even in log files. The server environment variables apply only to keys not stored here.',
  keyStored: 'Stored',
  keyFromEnv: 'From the server environment',
  keyNotSet: 'Not set',
  keyBy: 'by',
  keyEnvToo: 'the server environment has a value too; the one stored here wins',
  keyEnvOnly: 'The value from the server environment is in use; store another one here to replace it',
  keyNew: 'new key',
  keyReplace: 'Replace with a new key…',
  keyRemove: 'Remove',
  keyRemoveConfirm: 'Remove the stored key? The service stops unless the server environment has a value.',
  keyTest: 'Test',
  keyTesting: 'Testing…',
  keySaved: 'key saved',
  keyRemoved: 'key removed',
  keyTestApOk: 'AP accepted the key',
  keyTestApFeeds: "feeds on the station's plan",
  keyTestFailed: 'The test failed',
  keyAnthropicDesc: "The company's Anthropic account key, for the journalists' AI assistant; created at console.anthropic.com → API keys. Provider, model and effort are chosen on the page",
  keyElevenDesc: "The station's ElevenLabs key, for the AI voice that reads the journalists' voice-overs (Video hub); created at elevenlabs.io → Profile → API keys",
  keyTestElevenOk: 'ElevenLabs accepted the key',
  keyTestElevenVoices: 'voices',
  keyApDesc: "The AP Media API key of the station's plan (from the AP account or AP Customer Support). The Associated Press feeds are read with it; once saved they appear under Suggested in New feed, on the page",
  aiSettingsSaved: 'Settings saved',
  aiEnabledWith: 'the assistant is on with',
  aiStillOff: 'the assistant stays off',
  aiTest: 'Test',
  aiTesting: 'sending a test request…',
  aiTestOk: 'The provider answered',
  aiTestFailed: 'The test failed',
  importMenu: 'HPress import',
  importTitle: 'Import from HPress',
  importHint: 'Batches extracted from HPress (pnpm hpress extract, read-only) and loaded into this installation: stage → transform → validate → import → reconcile.',
  importRuns: 'Runs in this process',
  importBatches: 'Batches in the database',
  importStarted: 'Started',
  importBatch: 'Batch',
  importBy: 'By',
  importSource: 'Source',
  importInserted: 'Inserted',
  importUnchanged: 'Unchanged',
  importCounts: 'Counts',
  importLog: 'Report',
  importNone: 'No run since the last start',
  importTip: 'Loading is done with the command-line tool from a LAN machine that can see HPress (POST /api/admin/import/batches). The same batch can be loaded again without duplicates.',
  spell: 'Spelling',
  spellToggle: 'Spell check the script (red underline; click a word for suggestions)',
  spellNoSuggestions: 'No suggestion',
  spellAddWord: 'Add to dictionary',
  spellIgnore: 'Ignore',
  aiPanel: 'AI assistant',
  aiDisabled: 'AI help is not enabled on this installation (setting AI_PROVIDER).',
  aiHint: 'Every answer is a proposal: nothing changes in the story until you press Apply. The assistant adds no facts; always check names and numbers.',
  aiProofread: 'Spelling & grammar',
  aiTitles: 'Title ideas',
  aiShorten: 'Shorten to',
  aiSummary: 'Web summary',
  aiTranslate: 'Translate',
  aiTargetSeconds: 'Reading seconds',
  aiApply: 'Apply to the script',
  aiUseTitle: 'Use',
  aiNoChanges: 'No mistakes found',
  aiNoText: 'Write some text first',
  usersMenu: 'Users',
  rolesMenu: 'Roles',
  usersTitle: 'Users',
  usersHint: 'Accounts of the department: who signs in and with which role. Users are never deleted; they are deactivated.',
  usersShowInactive: 'include inactive',
  usersTip: 'A user without a password (migrated from HPress) cannot sign in until you set one. Changing the role or deactivating ends their sessions at once.',
  userNew: 'New user',
  userEdit: 'Edit user',
  displayName: 'Full name',
  role: 'Role',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  noPassword: 'no password',
  newPasswordOptional: 'New password (optional)',
  language: 'Language',
  updated: 'Updated',
  you: 'you',
  rolesTitle: 'Roles and permissions',
  rolesHint: 'A role is a set of permissions (the HPress letters: R read, A create, M own, C any, D delete, S order, Q rundown, P autocue). Changes apply at once to every user of the role.',
  rolesTip: 'Built-in roles can be changed but not deleted. The admin role always has every permission.',
  roleNew: 'New role',
  roleEdit: 'Edit role',
  roleKey: 'Key',
  roleName: 'Name',
  roleCopyFrom: 'Copy permissions from',
  roleDeleteConfirm: 'Delete the role',
  permissions: 'Permissions',
  users: 'Users',
  builtIn: 'built-in',
  allPermissions: 'all permissions',
  adminRoleFixed: 'The admin role always has every permission; only its name can change.',
  noPlayersYet: 'No player list has been received from the playout yet',
  ltoTagline: 'LTO tape archive · preview and restore',
  ltoStatTapes: 'tapes',
  ltoStatItems: 'items',
  ltoStatPreview: 'with preview',
  ltoStatOnTape: 'on tape',
  ltoStatRestoring: 'restoring',
  ltoAgent: 'Archive agent',
  ltoAgentOnline: 'online',
  ltoAgentOffline: 'offline',
  ltoAgentNone: 'never connected',
  ltoAgentNoneHint: 'The agent runs at the station next to the LTO drive: it writes the tapes, sends the preview copies and does the restores.',
  ltoInDrive: 'in the drive',
  ltoViewSearch: 'Search',
  ltoViewTapes: 'Tapes',
  ltoViewRestores: 'Restores',
  ltoSearchPlaceholder: 'Title, summary, comments or tape code (e.g. MS0050)…',
  ltoFilters: 'Filters',
  ltoOnlyPreview: 'With preview only',
  ltoWithSummary: 'With summary',
  ltoClearTape: 'All tapes',
  ltoCategoriesN: 'categories',
  ltoResults: 'items',
  ltoMore: 'There are more: narrow the search or raise the records.',
  ltoRobotSearch: 'Searching the tape library',
  ltoRobotFetch: 'The robot is fetching the tape',
  ltoPickItem: 'Pick an item to see it.',
  ltoPickTape: 'Pick a tape.',
  ltoCard: 'Card',
  ltoTape: 'Tape',
  ltoFile: 'File',
  ltoFormat: 'Format',
  ltoOnTape: 'On tape',
  ltoProxyBadge: 'Preview',
  ltoProxyHint: 'A small low-quality copy, only to watch the material. The full-quality file is on the tape.',
  ltoNoProxy: 'No preview',
  ltoNoProxyHint: 'The item was archived before preview copies were kept. Ask for a restore to see it.',
  ltoPickLabel: 'Video',
  ltoPickDrop: 'Drop the video here',
  ltoPickOr: 'or',
  ltoPickChoose: 'choose a file',
  ltoPickOther: 'Another file',
  ltoPickRemove: 'Remove the video',
  ltoPickHint: 'The preview (640×360) is made from it. The file itself is not kept: the full one is on the tape.',
  ltoPickReplace: 'The item already has a preview: a video here replaces it.',
  ltoPickLooking: 'Reading the file…',
  ltoPickBrowser: 'The preview is made here, in the browser: only it is sent, a few MB.',
  ltoPickServer: 'After Save the file is uploaded to the server',
  ltoPickServerWhy: 'The browser cannot open this kind of file, so the server makes the preview and then deletes the file. Keep the page open until it is sent.',
  ltoAbout: 'about',
  ltoAtSpeed: 'at',
  ltoAtLastSend: 'at the speed of the last upload',
  ltoUnderMinute: 'under a minute',
  ltoMinute: 'minute',
  ltoHour: 'hour',
  ltoHours: 'hours',
  ltoPickNoServer: 'The browser cannot read this file and the server has no FFmpeg: the archive agent will make the preview.',
  ltoPickNoPicture: 'The file has no picture.',
  ltoPickTooBig: 'The file is larger than the server takes',
  ltoTrayTitle: 'Previews',
  ltoJobMaking: 'Making the preview',
  ltoJobSendingPreview: 'Sending the preview',
  ltoJobSending: 'Sending the file to the server',
  ltoJobQueued: 'Waiting on the server',
  ltoJobProbing: 'The server is reading the file',
  ltoJobServer: 'The server is making the preview',
  ltoJobStoring: 'Saving',
  ltoJobDone: 'The preview is ready',
  ltoJobFailed: 'The preview was not made',
  ltoJobCancelled: 'Cancelled',
  ltoJobOpen: 'Open',
  ltoJobLeft: 'left',
  ltoJobStay: 'Keep this page open until it is done',
  ltoJobCancelAsk: 'Stop making the preview?',
  ltoAddPreview: 'Video for a preview',
  ltoAddPreviewHint: 'or drop a video here',
  ltoPreviewFrom: 'Preview',
  ltoSrcAgent: 'by the agent',
  ltoSrcBrowser: 'in the browser',
  ltoSrcServer: 'on the server',
  ltoNoTapeHint: 'The item has no tape code.',
  ltoRestoreTitle: 'Restore from tape',
  ltoRestoreTo: 'Deliver to',
  ltoWholeFile: 'Whole file',
  ltoPart: 'Part',
  ltoPartHint: 'Set IN and OUT on the preview (keys I and O) to ask for a part only.',
  ltoReason: 'What for (optional), e.g. "for the 20:00 bulletin"',
  ltoRestoreAsk: 'Ask for a restore',
  ltoRestoreAsked: 'The restore was asked for. Follow it here and under Restores.',
  ltoRestoreExisting: 'The same restore is already under way.',
  ltoManualHint: 'The item was archived before the agent: the archivist restores it by hand.',
  ltoManualAgentOff: 'The agent is not connected: the archivist restores it by hand.',
  ltoManualTarget: 'archivist',
  ltoItemRestores: 'The item\'s restores',
  ltoStRequested: 'Waiting',
  ltoStLoading: 'Loading tape',
  ltoStReading: 'Reading',
  ltoStDone: 'Done',
  ltoStFailed: 'Failed',
  ltoStCancelled: 'Cancelled',
  ltoMoveLoading: 'Loaded',
  ltoMoveDone: 'Done',
  ltoMoveDoneAsk: 'Where is the restored file? (name or path, optional)',
  ltoMoveFailed: 'Failed',
  ltoMoveFailedAsk: 'What went wrong? (optional)',
  ltoCancelAsk: 'Cancel the restore?',
  ltoScopeOpen: 'Under way',
  ltoScopeMine: 'Mine',
  ltoScopeAll: 'All',
  ltoRestoresCount: 'restores',
  ltoNowLoading: 'Loading a tape now',
  ltoNowReading: 'Reading from tape now',
  ltoNoOpenRestores: 'No restore under way.',
  ltoNoRestores: 'No restores.',
  ltoTapeSearch: 'Tape code…',
  ltoLocation: 'Place',
  ltoAllLocations: 'All places',
  ltoSortRecent: 'Most recent',
  ltoSortBarcode: 'By code',
  ltoTapesCount: 'tapes',
  ltoNoTapes: 'No tapes.',
  ltoItems: 'items',
  ltoSizeUnknown: 'capacity unknown',
  ltoLocLibrary: 'Library',
  ltoLocDrive: 'In the drive',
  ltoLocShelf: 'Shelf',
  ltoLocOffsite: 'Off site',
  ltoLocUnknown: 'Place unknown',
  ltoStateActive: 'In use',
  ltoStateFull: 'Full',
  ltoStateRetired: 'Retired',
  ltoGeneration: 'Generation',
  ltoGenUnknown: 'Generation unknown',
  ltoSlot: 'Slot / shelf',
  ltoSlotHint: 'e.g. Shelf B-12 or slot 34',
  ltoState: 'State',
  ltoNotes: 'Notes',
  ltoTapeSaved: 'Saved',
  ltoLastWritten: 'Last written',
  ltoOnThisTape: 'Items on this tape',
};

let current: Record<Key, string> = el;
export function setLocale(locale: string): void {
  current = locale === 'en' ? en : el;
  document.documentElement.lang = locale === 'en' ? 'en' : 'el';
}
export function t(key: Key): string {
  return current[key];
}
